(function(){
const __modules = {
"./entry.js": function(module, exports, __require) {
const { createRoyalFoodScannerApp } = __require("./main.js");

(() => {
  const globalState = window.__RoyalFoodScannerSectionState || (window.__RoyalFoodScannerSectionState = {
    instances: new WeakMap(),
    listenersAttached: false,
  });
  const instances = globalState.instances;

  function text(value) { return String(value || "").trim(); }

  function configFrom(root) {
    return {
      apiBaseUrl: text(root.dataset.apiBaseUrl) || "https://royal-food-scan-api.royal-athletes-tools.workers.dev",
      dailyLimit: text(root.dataset.dailyLimit) || "5",
      heading: text(root.dataset.heading),
      introText: text(root.dataset.introText),
      recommendedProductUrl: text(root.dataset.recommendedProductUrl),
      sectionId: text(root.dataset.sectionId),
    };
  }

  function initRoot(root) {
    if (!root || instances.has(root)) return;
    const mount = root.querySelector("[data-royal-food-scanner-app]") || root;
    mount.innerHTML = "";
    const instance = createRoyalFoodScannerApp(mount, configFrom(root));
    instances.set(root, instance);
    root.dataset.royalFoodScannerInitialized = "true";
  }

  function initAll(scope = document) {
    const roots = scope.matches?.("[data-royal-food-scanner]") ? [scope] : Array.from(scope.querySelectorAll?.("[data-royal-food-scanner]") || []);
    roots.forEach(initRoot);
  }

  function destroyAll(scope = document) {
    const roots = scope.matches?.("[data-royal-food-scanner]") ? [scope] : Array.from(scope.querySelectorAll?.("[data-royal-food-scanner]") || []);
    roots.forEach((root) => {
      const instance = instances.get(root);
      instance?.destroy?.();
      instances.delete(root);
      delete root.dataset.royalFoodScannerInitialized;
    });
  }

  function scheduleInitAll() {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => initAll(), { once: true });
    } else {
      initAll();
    }
  }

  if (!globalState.listenersAttached) {
    scheduleInitAll();
    document.addEventListener("shopify:section:load", (event) => initAll(event.target));
    document.addEventListener("shopify:section:unload", (event) => destroyAll(event.target));
    globalState.listenersAttached = true;
  } else {
    scheduleInitAll();
  }
})();

},
"./main.js": function(module, exports, __require) {
const { analyzeMeal: rawAnalyzeMeal, calculateMeal: rawCalculateMeal, searchFoods: rawSearchFoods } = __require("./api.js");
const { compressImage, createPreview, revokePreview, validateImage } = __require("./image-utils.js");
const { attachEditModalClickGuards, applyCatalogSelectionToEditValues, beginEditSave, canSubmitEdit, createEditCatalogSelection, completeEditSave, createEditValues, failEditSave, hasKnownPortionConversion, handleEditModalEscape, PENDING_FOOD_SEARCH_MESSAGE, saveEditedItem, syncEditPortionValues, validateEditCatalogSelection } = __require("./edit-flow.js");
const { preventCatalogSearchEnter, updateCatalogSearchDom } = __require("./catalog-search-flow.js");
const { getUsageStatus, incrementSuccessfulScan, markUsageLimitReached } = __require("./scan-limit.js");
const { renderLimitReachedCard, renderUsageText } = __require("./scan-limit-ui.js");
const { createRoyalReading } = __require("./royal-reading-engine.js");
const { loadRoyalGoals, saveRoyalGoals } = __require("./royal-goals.js");
const { ROYAL_READING_COPY } = __require("./royal-reading-copy.js");
const { MEAL_TYPE_REQUIRED_MESSAGE, isValidMealType, normalizeMealTypeValue, renderMealTypeSelector } = __require("./meal-type-ui.js");
const { HIDDEN_INGREDIENTS, addCatalogItem, addHiddenIngredient, addManualItem, createInitialState, createManualModeState, getPendingCount, mergeCalculationResult, normalizeAnalyzeResponse, removeItem, toCalculationItems } = __require("./state.js");
const { confidenceLabel, confidenceTone, createDebouncedSearch, describeApiError, escapeHtml, formatCalories, formatMacro, formatNumber, sourceLabel } = __require("./nutrition-ui.js");

function createRoyalFoodScannerApp(__royalAppRoot, __royalScannerConfig = {}) {
const app = __royalAppRoot;
const apiBaseUrl = __royalScannerConfig.apiBaseUrl || "https://royal-food-scan-api.royal-athletes-tools.workers.dev";
const dailyScanLimit = Number.isInteger(Number(__royalScannerConfig.dailyLimit)) && Number(__royalScannerConfig.dailyLimit) > 0 ? Number(__royalScannerConfig.dailyLimit) : undefined;
const configuredHeading = String(__royalScannerConfig.heading || "").trim();
const configuredIntro = String(__royalScannerConfig.introText || "").trim();
const configuredRecommendedProductUrl = String(__royalScannerConfig.recommendedProductUrl || "").trim();
const analyzeMeal = (params, options = {}) => rawAnalyzeMeal(params, { ...options, apiBaseUrl });
const calculateMeal = (items, options = {}) => rawCalculateMeal(items, { ...options, apiBaseUrl });
const searchFoods = (query, options = {}) => rawSearchFoods(query, { ...options, apiBaseUrl });
const UI_TEXT = Object.freeze({
  actions: {
    confirmDraft: "Confirmar alimentos y obtener mi Lectura Royal",
    editFoods: "Editar alimentos y porciones",
  },
  upload: {
    emptyTitle: "Arrastra una foto aquí o elige una opción",
    emptyHelp: "JPG, PNG o WEBP. La imagen se comprime antes de enviarse.",
    gallery: "Elegir de galería",
    camera: "Tomar fotografía",
    mobileCameraNote: "La captura directa funciona mejor desde un teléfono.",
  },
  fineTune: {
    eyebrow: "AJUSTE FINO OPCIONAL",
    title: "¿Hay algo que la foto no muestra?",
    description: "Aceites, aderezos, queso o crema pueden cambiar significativamente las calorías.",
  },
  missingFoods: {
    eyebrow: "AGREGAR ALIMENTOS FALTANTES — OPCIONAL",
    title: "¿La IA dejó algún alimento fuera?",
    description: "Busca en el catálogo Royal o agrega un alimento personalizado.",
    catalogTab: "Buscar en el catálogo",
    customTab: "Agregar personalizado",
    optional: "Opcional",
  },
  goals: {
    eyebrow: "OBJETIVOS ROYAL — OPCIONAL",
    title: "Personaliza tu Lectura Royal",
    description: "Agrega tus metas diarias para recibir una lectura más personalizada. Puedes omitir este paso y recibir una evaluación general.",
    contextualAction: "Personalizar con mis objetivos Royal",
    personalizedStatus: "Lectura basada en tus objetivos Royal",
    editAction: "Editar objetivos",
    formTitle: "Objetivos Royal",
    dailyCalories: "Calorías diarias",
    dailyProtein: "Proteína diaria (g)",
    goal: "Objetivo",
    save: "Guardar objetivos",
    invalid: "Ingresa calorías y proteína dentro de un rango razonable.",
  },
});
const scanMessages = [
  "Identificando alimentos",
  "Estimando porciones",
  "Revisando preparación",
  "Calculando calorías y macros",
  "Preparando tu resultado Royal",
];

let state = createInitialState();
let activePreviewUrl = null;
let editModal = null;
let fineTuneOpen = false;
let missingFoodsOpen = false;
let missingFoodsMode = "catalog";
let editFoodsOpen = false;
let royalGoals = loadRoyalGoals();
let goalsPanelOpen = false;
let goalsPanelContext = "scanner";
let goalsFormError = null;
let selectedCatalogFood = null;
let selectedHiddenFoodKey = null;
let catalogSearch = { query: "", results: [], loading: false };
let catalogAddDraft = {};
let manualFoodDraft = {};
let mealTypeError = null;
let scanMessageIndex = 0;
let scanTimer = null;
let analyzing = false;

const debouncedCatalogSearch = createDebouncedSearch(async (query) => {
  catalogSearch = { ...catalogSearch, query, loading: true };
  updateCatalogSearchPanels();
  const response = await searchFoods(query, { limit: 10 });
  catalogSearch = { query, results: response.items || [], loading: false };
  updateCatalogSearchPanels();
  return response;
}, 300);

const debouncedEditFoodSearch = createDebouncedSearch(async (query) => {
  if (!editModal) {
    return { success: true, query, items: [] };
  }

  editModal = {
    ...editModal,
    foodSearch: { ...(editModal.foodSearch || {}), query, loading: true },
  };
  updateEditFoodSearchPanel();
  const response = await searchFoods(query, { limit: 8 });

  if (editModal?.foodSearch?.query === query) {
    editModal = {
      ...editModal,
      foodSearch: {
        ...(editModal.foodSearch || {}),
        query,
        results: response.items || [],
        loading: false,
      },
    };
    updateEditFoodSearchPanel();
  }

  return response;
}, 300);

function setState(patch) {
  state = { ...state, ...patch };
  render();
}

function clearError() {
  state = { ...state, error: null };
}

function setError(error) {
  state = {
    ...state,
    loading: false,
    error: describeApiError(error),
  };
  render();
}

function startScanMessages() {
  stopScanMessages();
  scanMessageIndex = 0;
  scanTimer = setInterval(() => {
    scanMessageIndex = (scanMessageIndex + 1) % scanMessages.length;
    render();
  }, 1400);
}

function stopScanMessages() {
  if (scanTimer) {
    clearInterval(scanTimer);
    scanTimer = null;
  }
}

function render() {
  const usage = getUsageStatus(localStorage, Date.now(), dailyScanLimit);
  app.innerHTML = [
    renderScanner(usage),
    renderWorkspace(usage),
    renderModal(),
  ].join("");
  bindEditModalClickGuards();
}

function closeEditModal() {
  if (!editModal || editModal.isSaving) {
    return false;
  }

  editModal = null;
  render();
  return true;
}

function bindEditModalClickGuards() {
  const modalContent = app.querySelector("[data-modal]");

  attachEditModalClickGuards({
    backdrop: app.querySelector("[data-modal-backdrop]"),
    modalContent,
    closeEditModal,
  });

  bindEditModalActionHandlers(modalContent);
}

function bindEditModalActionHandlers(modalContent) {
  if (!modalContent || modalContent.dataset?.editActionListenersAttached === "true") {
    return false;
  }

  modalContent.dataset.editActionListenersAttached = "true";
  modalContent.addEventListener("click", handleEditModalActionClick);
  return true;
}

function handleEditModalActionClick(event) {
  const actionElement = event.target.closest("[data-action]");

  if (!actionElement || !event.currentTarget.contains(actionElement)) {
    return false;
  }

  const action = actionElement.dataset.action;

  if (action === "edit-change-food") {
    event.preventDefault();
    openEditFoodSearch();
    return true;
  }

  if (action === "select-edit-food") {
    event.preventDefault();
    selectEditFoodResult(actionElement.dataset.foodKey);
    return true;
  }

  return false;
}

function scrollToElement(selector) {
  requestAnimationFrame(() => {
    app.querySelector(selector)?.scrollIntoView({ behavior: "smooth", block: "start" });
  });
}

function renderScanner(usage) {
  const limitText = renderUsageText(usage);
  const hasImage = Boolean(state.imagePreview);
  const compact = hasImage && ["review", "final"].includes(state.currentScreen);
  const scannerCardClass = "card scanner-card" +
    (hasImage ? " scanner-card--with-preview" : "") +
    (compact ? " scanner-card--compact" : "");

  return "" +
    '<main class="section scanner-section" id="scanner">' +
      renderError() +
      '<div class="grid scanner-grid scanner-grid--single">' +
        '<section class="' + scannerCardClass + '" aria-labelledby="upload-title">' +
          (usage.isLimitReached ? "" : '<div class="usage-pill">' + escapeHtml(limitText) + '</div>') +
          (usage.isLimitReached ? renderLimitReached(usage) : "") +
          '<div class="scanner-card__intro">' +
            '<h2 id="upload-title">Sube una fotografía de tu comida</h2>' +
            '<p class="muted">Usa una imagen clara, bien iluminada y donde se vea el plato completo.</p>' +
          '</div>' +
          renderUploadArea() +
          renderPreviewAndContext(usage) +
          (!hasImage && !usage.isLimitReached ? '<div class="scanner-card__manual"><button class="btn btn--ghost" type="button" data-action="manual-mode">Continuar en modo manual</button></div>' : "") +
        '</section>' +
      '</div>' +
    '</main>';
}

function renderLimitReached(usage) {
  return renderLimitReachedCard(usage, escapeHtml);
}

function renderUploadArea() {
  const hasImage = Boolean(state.imagePreview);
  const compact = hasImage && ["review", "final"].includes(state.currentScreen);
  const uploadClass = "upload-zone" +
    (hasImage ? " upload-zone--has-image" : " upload-zone--empty") +
    (compact ? " upload-zone--compact" : "");
  const ariaLabel = hasImage
    ? "Vista previa de la fotografía de comida seleccionada"
    : "Subir fotografía de comida";

  const emptyContent = "" +
    '<div class="upload-empty">' +
      '<span class="upload-empty__mark" aria-hidden="true">+</span>' +
      '<strong>' + escapeHtml(UI_TEXT.upload.emptyTitle) + '</strong>' +
      '<p class="muted">' + escapeHtml(UI_TEXT.upload.emptyHelp) + '</p>' +
      '<div class="btn-row upload-empty__actions">' +
        '<button class="btn btn--dark" type="button" data-action="choose-gallery">' + escapeHtml(UI_TEXT.upload.gallery) + '</button>' +
        '<button class="btn btn--primary" type="button" data-action="choose-camera">' + escapeHtml(UI_TEXT.upload.camera) + '</button>' +
      '</div>' +
      '<p class="muted upload-camera-note">' + escapeHtml(UI_TEXT.upload.mobileCameraNote) + '</p>' +
    '</div>';

  const previewContent = hasImage
    ? "" +
      '<div class="upload-preview-frame">' +
        '<img class="upload-preview-image" src="' + escapeHtml(state.imagePreview) + '" alt="Vista previa de la comida seleccionada" />' +
      '</div>' +
      '<div class="btn-row upload-preview-actions">' +
        '<button class="btn btn--ghost" type="button" data-action="change-photo">Cambiar fotografía</button>' +
        '<button class="btn btn--danger" type="button" data-action="remove-photo">Eliminar fotografía</button>' +
      '</div>'
    : emptyContent;

  return "" +
    '<div class="' + uploadClass + '" id="drop-zone" tabindex="0" role="button" aria-label="' + escapeHtml(ariaLabel) + '">' +
      previewContent +
      '<input class="file-input" id="gallery-input" type="file" accept="image/jpeg,image/png,image/webp" data-file-input />' +
      '<input class="file-input" id="camera-input" type="file" accept="image/*" capture="environment" data-file-input />' +
    '</div>';
}

function renderPreviewAndContext(usage) {
  if (!state.imagePreview) {
    return state.loading ? renderLoading() : "";
  }

  const compact = ["review", "final"].includes(state.currentScreen);
  const analyzeLabel = compact ? "Analizar de nuevo" : "Analizar mi comida";
  const contextClass = "preview-context" + (compact ? " preview-context--compact" : "");

  return "" +
    '<section class="' + contextClass + '" aria-label="Contexto de la fotografía">' +
      renderMealTypeSelector({
        id: "photo-meal-type",
        value: state.mealType,
        title: "Tipo de comida opcional",
        description: "Selecciona una opción si quieres contextualizar mejor la lectura.",
        className: "preview-context__group",
      }) +
      renderPreAnalysisGoalsAccordion() +
      '<div class="preview-context__footer">' +
        '<button class="btn btn--primary" type="button" data-action="analyze" ' + (state.loading || usage.isLimitReached ? "disabled" : "") + '>' + analyzeLabel + '</button>' +
      '</div>' +
      (state.loading ? renderLoading() : "") +
    '</section>';
}

function renderLoading() {
  return "" +
    "<div class=\"loading-box\" role=\"status\" aria-live=\"polite\">" +
      "<strong>" + escapeHtml(scanMessages[scanMessageIndex]) + "</strong>" +
      "<div class=\"scan-animation\" aria-hidden=\"true\"></div>" +
      "<span>Esto puede tardar algunos segundos.</span>" +
    "</div>";
}

function renderError() {
  if (!state.error) return "";

  return "" +
    "<div class=\"error-box\" role=\"alert\" aria-live=\"assertive\">" +
      "<h3>" + escapeHtml(state.error.title) + "</h3>" +
      "<p>" + escapeHtml(state.error.text) + "</p>" +
      "<div class=\"btn-row\">" +
        (state.error.retry ? "<button class=\"btn btn--dark\" type=\"button\" data-action=\"retry\">Reintentar</button>" : "") +
        (state.error.manual ? "<button class=\"btn btn--ghost\" type=\"button\" data-action=\"manual-mode\">Usar modo manual</button>" : "") +
      "</div>" +
    "</div>";
}

function renderWorkspace() {
  if (!["review", "manual", "final"].includes(state.currentScreen) && state.calculatedItems.length === 0) {
    return "";
  }

  if (state.resultStatus === "confirmed") {
    return renderFinalResult();
  }

  return "" +
    '<section class="section" id="review">' +
      '<div class="review-flow">' +
        '<div class="review-heading">' +
          '<h2>Resultado provisional</h2>' +
          '<p class="muted">La IA propone los alimentos y sus porciones. Revisa cualquier detalle antes de obtener tu Lectura Royal.</p>' +
        '</div>' +
        renderTotalsPanel({ title: "Resumen provisional", eyebrow: "RESULTADO PROVISIONAL" }) +
        renderReviewSummary() +
        renderDraftReviewSection() +
      '</div>' +
    '</section>';
}

function renderDraftReviewSection() {
  return "" +
    '<section class="card review-confirmation" id="food-review" aria-labelledby="food-review-title">' +
      '<div class="eyebrow">REVISIÓN</div>' +
      '<h3 id="food-review-title">Revisa y confirma los alimentos</h3>' +
      '<p class="muted">La IA propone los alimentos y sus porciones. Corrige cualquier detalle antes de obtener tu Lectura Royal.</p>' +
      renderManualMealTypeSection() +
      renderFoodItems() +
      renderFineTuneAccordion() +
      renderManualAddSection() +
      '<div class="review-confirmation__actions">' +
        '<button class="btn btn--primary" type="button" data-action="confirm-draft" ' + (state.calculatedItems.length === 0 ? "disabled" : "") + '>' + escapeHtml(UI_TEXT.actions.confirmDraft) + '</button>' +
      '</div>' +
    '</section>';
}

function renderManualMealTypeSection() {
  if (!state.manualMode && !mealTypeError) {
    return "";
  }

  return "" +
    '<div class="manual-mode-context">' +
      renderMealTypeSelector({
        id: "manual-meal-type",
        value: state.mealType,
        error: mealTypeError || "",
        className: "card manual-meal-type-card",
      }) +
      (!state.imagePreview ? renderPreAnalysisGoalsAccordion() : "") +
    '</div>';
}

function renderReviewSummary() {
  const items = state.calculatedItems;
  const visibleCount = items.filter((item) => item.source !== "hidden_ingredient").length;
  const hiddenCount = items.filter((item) => item.source === "hidden_ingredient").length;
  const pendingCount = getPendingCount(items);
  const pieces = [
    visibleCount === 1 ? "1 alimento detectado" : visibleCount + " alimentos detectados",
  ];

  if (hiddenCount > 0) {
    pieces.push(hiddenCount === 1 ? "1 ingrediente agregado" : hiddenCount + " ingredientes agregados");
  }

  pieces.push(pendingCount > 0
    ? (pendingCount === 1 ? "1 pendiente" : pendingCount + " pendientes")
    : "Total completo");

  return '<p class="review-status ' + (pendingCount > 0 ? 'review-status--pending' : 'review-status--complete') + '" role="status">' + escapeHtml(pieces.join(" · ")) + '</p>';
}

function renderSmallStat(label, value) {
  return "<div class=\"metric\"><span>" + escapeHtml(label) + "</span><strong>" + escapeHtml(value) + "</strong></div>";
}

function renderFoodItems() {
  if (state.calculatedItems.length === 0) {
    return "" +
      '<div class="card review-empty">' +
        '<h3>Agrega un alimento para comenzar</h3>' +
        '<p class="muted">Puedes buscar en el catálogo, agregar un ingrediente oculto o capturar nutrición manual.</p>' +
      '</div>';
  }

  return '<div class="item-grid">' + state.calculatedItems.map(renderFoodCard).join("") + '</div>';
}

function renderFoodCard(item) {
  const identity = item.identity_confidence ? confidenceLabel("identity", item.identity_confidence) : "Agregado manualmente";
  const portion = confidenceLabel("portion", item.portion_confidence);

  return "" +
    '<article class="card food-card">' +
      '<div class="food-card__head">' +
        '<div>' +
          '<h3>' + escapeHtml(item.name) + '</h3>' +
          '<p class="muted">' + escapeHtml(item.preparation || sourceLabel(item.source)) + '</p>' +
        '</div>' +
        '<strong class="food-card__calories">' + formatCalories(item.calories) + '</strong>' +
      '</div>' +
      '<div class="food-card__metrics">' +
        renderMetric("Peso", item.weight_g !== null ? formatNumber(item.weight_g, 1) + " g" : "—") +
        renderMetric("Proteína", formatMacro(item.protein_g)) +
        renderMetric("Carbs", formatMacro(item.carbs_g)) +
        renderMetric("Grasas", formatMacro(item.fat_g)) +
      '</div>' +
      '<p class="muted food-card__quantity">Cantidad: ' + escapeHtml(item.source === "manual_nutrition" ? (item.quantity_label || "Porción completa") : (formatNumber(item.quantity, 1) + " " + (item.unit || ""))) + '</p>' +
      '<div class="badges">' +
        '<span class="badge badge--' + confidenceTone(item.identity_confidence) + '">' + escapeHtml(identity) + '</span>' +
        '<span class="badge badge--' + confidenceTone(item.portion_confidence) + '">' + escapeHtml(portion) + '</span>' +
        '<span class="badge badge--neutral">' + escapeHtml(item.nutrition_source || "Fuente por revisar") + '</span>' +
      '</div>' +
      '<div class="btn-row food-card__actions">' +
        '<button class="btn btn--ghost" type="button" data-action="edit-item" data-id="' + escapeHtml(item.id) + '">Editar</button>' +
        '<button class="btn btn--danger" type="button" data-action="delete-item" data-id="' + escapeHtml(item.id) + '">Eliminar</button>' +
      '</div>' +
    '</article>';
}

function renderMetric(label, value) {
  return "<div class=\"metric\"><span>" + escapeHtml(label) + "</span><strong>" + escapeHtml(value) + "</strong></div>";
}

function renderTotalsPanel(options = {}) {
  const title = options.title || "Totales actuales";
  const headingTag = options.headingTag || "h3";
  const eyebrow = options.eyebrow || "Resumen nutricional";

  return "" +
    '<section class="panel panel--dark totals-panel" id="nutrition-result">' +
      '<div class="eyebrow">' + escapeHtml(eyebrow) + '</div>' +
      '<' + headingTag + '>' + escapeHtml(title) + '</' + headingTag + '>' +
      renderMacroGrid(state.totals) +
      '<div class="totals-range"><span>Rango estimado</span><strong>' + formatNumber(state.estimatedRange.calories_min, 0) + '–' + formatNumber(state.estimatedRange.calories_max, 0) + ' kcal</strong></div>' +
      (!state.estimatedRange.range_complete ? '<p class="muted">Este rango todavía no incluye todos los alimentos pendientes.</p>' : "") +
      (!state.totals.totals_complete ? '<p class="muted">No todos los alimentos pudieron calcularse. Revisa los elementos pendientes.</p>' : "") +
    '</section>';
}

function createRoyalReadingInput() {
  return {
    mealType: state.mealType,
    totals: state.totals,
    estimatedRange: state.estimatedRange,
    detectedItems: state.calculatedItems,
    possibleHiddenIngredients: state.possibleHiddenIngredients,
    analysisConfidence: state.analysisConfidence,
    totalsComplete: state.totals.totals_complete,
    itemsPending: state.totals.items_pending,
    goals: royalGoals,
  };
}

function createCurrentRoyalReading() {
  return createRoyalReading(createRoyalReadingInput());
}

function withConfiguredRecommendedProductUrl(recommendation) {
  if (!recommendation || !configuredRecommendedProductUrl) {
    return recommendation;
  }

  return { ...recommendation, productUrl: configuredRecommendedProductUrl };
}

function renderRoyalReadingCard(reading = createCurrentRoyalReading()) {
  const messages = [
    renderRoyalMessageBlock(ROYAL_READING_COPY.labels.positive, reading.positiveMessage, "positive"),
    renderRoyalMessageBlock(ROYAL_READING_COPY.labels.watch, reading.watchMessage, "watch"),
    renderRoyalMessageBlock(ROYAL_READING_COPY.labels.action, reading.actionMessage, "action"),
  ].filter(Boolean).join("");

  return "" +
    '<section class="card royal-reading-card" id="royal-reading" aria-labelledby="royal-reading-title">' +
      '<div class="royal-reading-card__head">' +
        '<div>' +
          '<div class="eyebrow">' + escapeHtml(ROYAL_READING_COPY.labels.reading) + '</div>' +
          '<h3 id="royal-reading-title">' + escapeHtml(reading.headline) + '</h3>' +
        '</div>' +
        '<span class="royal-reading-mode">' + escapeHtml(reading.mode === "personalized" ? "Personalizada" : "Contextual") + '</span>' +
      '</div>' +
      '<p class="royal-reading-summary">' + escapeHtml(reading.summary) + '</p>' +
      (messages ? '<div class="royal-reading-messages">' + messages + '</div>' : '') +
      renderRoyalGoalsControl(reading.mode) +
    '</section>';
}

function renderRoyalMessageBlock(label, message, tone) {
  if (!message) return "";

  return "" +
    '<article class="royal-reading-message royal-reading-message--' + tone + '">' +
      '<span>' + escapeHtml(label) + '</span>' +
      '<p>' + escapeHtml(message) + '</p>' +
    '</article>';
}

function renderRoyalProductRecommendation(recommendation) {
  if (!recommendation) return "";

  return "" +
    '<article class="royal-product-card">' +
      '<div class="eyebrow">' + escapeHtml(recommendation.label) + '</div>' +
      '<h4>' + escapeHtml(recommendation.headline) + '</h4>' +
      '<p>' + escapeHtml(recommendation.text) + '</p>' +
      '<div class="royal-product-card__product">' +
        '<strong>' + escapeHtml(recommendation.productName) + '</strong>' +
        '<p>' + escapeHtml(recommendation.productText) + '</p>' +
      '</div>' +
      '<p>' + escapeHtml(recommendation.contextText) + '</p>' +
      '<p class="muted">' + escapeHtml(recommendation.realFoodText) + '</p>' +
      (recommendation.productUrl ? '<a class="btn btn--dark" href="' + escapeHtml(recommendation.productUrl) + '">' + escapeHtml(recommendation.ctaText) + '</a>' : '') +
    '</article>';
}

function renderCurrentRoyalProductRecommendation(reading = createCurrentRoyalReading()) {
  return renderRoyalProductRecommendation(withConfiguredRecommendedProductUrl(reading.productRecommendation));
}

function renderRoyalGoalsControl(mode) {
  const status = royalGoals
    ? '<p class="royal-goals-status">' + escapeHtml(UI_TEXT.goals.personalizedStatus) + '<br><span>' + escapeHtml(formatRoyalGoalsSummary(royalGoals)) + '</span></p><button class="btn btn--ghost" type="button" data-action="toggle-royal-goals" data-goals-context="reading">' + escapeHtml(UI_TEXT.goals.editAction) + '</button>'
    : '<button class="btn btn--ghost" type="button" data-action="toggle-royal-goals" data-goals-context="reading">' + escapeHtml(UI_TEXT.goals.contextualAction) + '</button>';

  return "" +
    '<div class="royal-goals-control" data-mode="' + escapeHtml(mode) + '">' +
      '<div class="royal-goals-control__summary">' + status + '</div>' +
      (goalsPanelOpen && goalsPanelContext === "reading" ? renderRoyalGoalsForm("reading") : '') +
    '</div>';
}

function renderPreAnalysisGoalsAccordion() {
  const expanded = goalsPanelOpen && goalsPanelContext === "scanner";
  const contentId = "royal-goals-content-scanner";
  const summary = royalGoals
    ? '<span class="royal-goals-pill">' + escapeHtml(formatRoyalGoalsSummary(royalGoals)) + '</span>'
    : '<span class="royal-goals-pill royal-goals-pill--muted">Modo contextual</span>';

  return "" +
    '<section class="royal-goals-accordion ' + (expanded ? 'is-open' : 'is-collapsed') + '" id="royal-goals-accordion">' +
      '<button class="royal-goals-trigger" type="button" data-action="toggle-royal-goals" data-goals-context="scanner" aria-expanded="' + String(expanded) + '" aria-controls="' + contentId + '">' +
        '<span class="royal-goals-trigger__copy">' +
          '<span class="eyebrow">' + escapeHtml(UI_TEXT.goals.eyebrow) + '</span>' +
          '<strong>' + escapeHtml(UI_TEXT.goals.title) + '</strong>' +
          '<small>' + escapeHtml(UI_TEXT.goals.description) + '</small>' +
        '</span>' +
        summary +
        '<span class="fine-tune-trigger__icon" aria-hidden="true">' + (expanded ? '−' : '+') + '</span>' +
      '</button>' +
      (expanded ? '<div class="royal-goals-accordion__content" id="' + contentId + '">' + renderRoyalGoalsForm("scanner") + '</div>' : '') +
    '</section>';
}

function formatRoyalGoalsSummary(goals) {
  if (!goals) {
    return "Modo contextual";
  }

  return [
    Number(goals.dailyCalories).toLocaleString("es-MX") + " kcal",
    Number(goals.dailyProtein).toLocaleString("es-MX") + " g proteína",
    royalGoalLabel(goals.goal),
  ].join(" · ");
}

function royalGoalLabel(goal) {
  const labels = {
    lose_fat: "Perder grasa",
    maintain: "Mantener",
    gain_muscle: "Ganar músculo",
    unknown: "Objetivo general",
  };

  return labels[goal] || labels.unknown;
}

function renderRoyalGoalsForm(context = "scanner") {
  const values = royalGoals || { dailyCalories: "", dailyProtein: "", goal: "unknown" };
  const goalOptions = [
    ["unknown", "No especificar"],
    ["lose_fat", "Perder grasa"],
    ["maintain", "Mantener"],
    ["gain_muscle", "Ganar músculo"],
  ];

  return "" +
    '<form class="royal-goals-form form-grid" id="royal-goals-panel-' + escapeHtml(context) + '" data-form="royal-goals">' +
      '<h4>' + escapeHtml(UI_TEXT.goals.formTitle) + '</h4>' +
      (goalsFormError ? '<div class="error-box" role="alert"><p>' + escapeHtml(goalsFormError) + '</p></div>' : '') +
      '<label>' + escapeHtml(UI_TEXT.goals.dailyCalories) + '<input name="dailyCalories" type="number" min="1000" max="6000" step="1" value="' + escapeHtml(values.dailyCalories ?? "") + '" required /></label>' +
      '<label>' + escapeHtml(UI_TEXT.goals.dailyProtein) + '<input name="dailyProtein" type="number" min="40" max="350" step="1" value="' + escapeHtml(values.dailyProtein ?? "") + '" required /></label>' +
      '<label>' + escapeHtml(UI_TEXT.goals.goal) + '<select name="goal">' + goalOptions.map(([value, label]) => '<option value="' + value + '" ' + (values.goal === value ? 'selected' : '') + '>' + escapeHtml(label) + '</option>').join("") + '</select></label>' +
      '<input type="hidden" name="source" value="manual" />' +
      '<button class="btn btn--dark" type="submit">' + escapeHtml(UI_TEXT.goals.save) + '</button>' +
    '</form>';
}


function renderMacroGrid(totals) {
  return "" +
    "<div class=\"macro-grid\">" +
      renderMacroCard("Calorías", formatCalories(totals.calories)) +
      renderMacroCard("Proteína", formatMacro(totals.protein_g)) +
      renderMacroCard("Carbohidratos", formatMacro(totals.carbs_g)) +
      renderMacroCard("Grasas", formatMacro(totals.fat_g)) +
    "</div>";
}

function renderMacroCard(label, value) {
  return "<div class=\"macro-card\"><span>" + escapeHtml(label) + "</span><strong>" + escapeHtml(value) + "</strong></div>";
}


function getHiddenIngredientSuggestions() {
  return Array.isArray(state.possibleHiddenIngredients)
    ? state.possibleHiddenIngredients.filter((item) => typeof item === "string" && item.trim()).slice(0, 3)
    : [];
}

function normalizeSuggestionText(value) {
  return String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();
}

function matchHiddenIngredientSuggestion(value) {
  const text = normalizeSuggestionText(value);
  const patterns = [
    ["olive_oil", ["aceite de oliva", "olive oil"]],
    ["cooking_oil", ["aceite vegetal", "aceite de coccion", "aceite para cocinar", "cooking oil", "vegetable oil", "aceite", "oil"]],
    ["butter", ["mantequilla", "butter"]],
    ["mayonnaise", ["mayonesa", "mayo", "mayonnaise"]],
    ["sugar", ["azucar", "sugar"]],
    ["vinaigrette_dressing", ["vinagreta", "vinaigrette"]],
    ["creamy_dressing", ["aderezo cremoso", "aderezo", "dressing"]],
    ["cream", ["crema", "cream"]],
    ["cheese_generic", ["queso", "cheese"]],
  ];

  const match = patterns.find(([, aliases]) => aliases.some((alias) => text.includes(alias)));
  return match ? match[0] : "";
}

function renderFineTuneSuggestions() {
  const suggestions = getHiddenIngredientSuggestions();
  if (suggestions.length === 0) {
    return "";
  }

  return "" +
    '<div class="fine-tune-suggestions" aria-label="Sugerencias de ingredientes no visibles">' +
      '<span class="fine-tune-hint">Recomendado</span>' +
      suggestions.map((suggestion) => {
        const match = matchHiddenIngredientSuggestion(suggestion);
        const label = normalizeSuggestionText(suggestion).includes("puede faltar")
          ? suggestion
          : "Puede faltar " + suggestion;

        return '<button class="fine-tune-suggestion" type="button" data-action="hidden-suggestion" data-food-key="' + escapeHtml(match) + '">' + escapeHtml(label) + '</button>';
      }).join("") +
    '</div>';
}

function renderFineTuneAccordion() {
  const expanded = fineTuneOpen;

  return "" +
    '<section class="card fine-tune-accordion ' + (expanded ? 'is-open' : 'is-collapsed') + '" id="fine-tune-accordion">' +
      '<button class="fine-tune-trigger" type="button" data-action="toggle-fine-tune" aria-expanded="' + String(expanded) + '" aria-controls="fine-tune-content">' +
        '<span class="fine-tune-trigger__copy">' +
          '<span class="eyebrow">' + escapeHtml(UI_TEXT.fineTune.eyebrow) + '</span>' +
          '<strong>' + escapeHtml(UI_TEXT.fineTune.title) + '</strong>' +
          '<small>' + escapeHtml(UI_TEXT.fineTune.description) + '</small>' +
        '</span>' +
        '<span class="fine-tune-trigger__icon" aria-hidden="true">' + (expanded ? '−' : '+') + '</span>' +
      '</button>' +
      (expanded ? '<div class="fine-tune-content" id="fine-tune-content">' + renderFineTuneSuggestions() + renderHiddenIngredientControls() + '</div>' : '') +
    '</section>';
}

function renderHiddenIngredientControls() {
  const selected = selectedHiddenFoodKey ? HIDDEN_INGREDIENTS.find((item) => item.food_key === selectedHiddenFoodKey) : null;

  return "" +
    '<div class="fine-tune-block fine-tune-block--hidden">' +
      '<div class="chips">' +
        HIDDEN_INGREDIENTS.map((ingredient) =>
          '<button class="chip" type="button" data-action="select-hidden" data-food-key="' + ingredient.food_key + '" aria-pressed="' + String(selectedHiddenFoodKey === ingredient.food_key) + '">' + escapeHtml(ingredient.label) + '</button>',
        ).join("") +
        '<button class="chip" type="button" data-action="focus-manual">Otro</button>' +
      '</div>' +
      (selected ? renderHiddenForm(selected) : "") +
    '</div>';
}

function renderHiddenIngredients() {
  return renderFineTuneAccordion();
}

function renderHiddenForm(ingredient) {
  return "" +
    "<form class=\"form-grid\" id=\"hidden-ingredient-form\" data-form=\"hidden\">" +
      "<h4>Confirmar " + escapeHtml(ingredient.label) + "</h4>" +
      "<label>Cantidad<input name=\"quantity\" type=\"number\" min=\"0.1\" step=\"0.1\" value=\"" + ingredient.defaultQuantity + "\" required /></label>" +
      "<label>Unidad<select name=\"unit\">" + ingredient.units.map((unit) => "<option value=\"" + unit + "\" " + (unit === ingredient.defaultUnit ? "selected" : "") + ">" + unit + "</option>").join("") + "</select></label>" +
      "<button class=\"btn btn--dark\" type=\"submit\">Agregar ingrediente</button>" +
    "</form>";
}

function renderManualAddSection() {
  const expanded = missingFoodsOpen;
  const contentId = "missing-foods-content";

  return "" +
    '<section class="card missing-foods-accordion ' + (expanded ? 'is-open' : 'is-collapsed') + '" id="missing-foods-accordion">' +
      '<button class="missing-foods-trigger" type="button" data-action="toggle-missing-foods" aria-expanded="' + String(expanded) + '" aria-controls="' + contentId + '">' +
        '<span class="missing-foods-trigger__copy">' +
          '<span class="eyebrow">' + escapeHtml(UI_TEXT.missingFoods.eyebrow) + '</span>' +
          '<strong>' + escapeHtml(UI_TEXT.missingFoods.title) + '</strong>' +
          '<small>' + escapeHtml(UI_TEXT.missingFoods.description) + '</small>' +
        '</span>' +
        '<span class="missing-foods-summary">' + escapeHtml(formatMissingFoodsSummary()) + '</span>' +
        '<span class="fine-tune-trigger__icon" aria-hidden="true">' + (expanded ? '−' : '+') + '</span>' +
      '</button>' +
      (expanded ? '<div class="missing-foods-content" id="' + contentId + '">' + renderMissingFoodsTabs() + renderMissingFoodsActivePanel() + '</div>' : '') +
    '</section>';
}

function getManuallyAddedFoodCount() {
  return state.calculatedItems.filter((item) => item.source === "manual_catalog" || item.source === "manual_nutrition").length;
}

function formatMissingFoodsSummary() {
  const count = getManuallyAddedFoodCount();

  if (count === 0) {
    return UI_TEXT.missingFoods.optional;
  }

  return count === 1 ? "1 alimento agregado" : count + " alimentos agregados";
}

function renderMissingFoodsTabs() {
  const catalogSelected = missingFoodsMode === "catalog";
  const customSelected = missingFoodsMode === "custom";

  return "" +
    '<div class="missing-foods-tabs" role="tablist" aria-label="Método para agregar alimentos">' +
      '<button class="missing-foods-tab" id="missing-foods-tab-catalog" type="button" role="tab" data-action="missing-foods-mode" data-mode="catalog" aria-selected="' + String(catalogSelected) + '" aria-controls="missing-foods-panel-catalog" tabindex="' + (catalogSelected ? "0" : "-1") + '">' + escapeHtml(UI_TEXT.missingFoods.catalogTab) + '</button>' +
      '<button class="missing-foods-tab" id="missing-foods-tab-custom" type="button" role="tab" data-action="missing-foods-mode" data-mode="custom" aria-selected="' + String(customSelected) + '" aria-controls="missing-foods-panel-custom" tabindex="' + (customSelected ? "0" : "-1") + '">' + escapeHtml(UI_TEXT.missingFoods.customTab) + '</button>' +
    '</div>';
}

function renderMissingFoodsActivePanel() {
  if (missingFoodsMode === "custom") {
    return '<div id="missing-foods-panel-custom" role="tabpanel" aria-labelledby="missing-foods-tab-custom">' + renderManualFoodForm() + '</div>';
  }

  return '<div id="missing-foods-panel-catalog" role="tabpanel" aria-labelledby="missing-foods-tab-catalog">' + renderFoodSearch() + '</div>';
}

function renderFoodSearch() {
  return "" +
    '<section class="card support-card support-card--catalog" id="food-search-card">' +
      '<div class="eyebrow">Catálogo local</div>' +
      '<h3>Agregar alimento manualmente</h3>' +
      '<label>Buscar en el catálogo<input id="food-search" value="' + escapeHtml(catalogSearch.query) + '" placeholder="Ejemplo: pollo, arroz, huevo" autocomplete="off" /></label>' +
      '<p class="muted">Escribe al menos dos caracteres. La búsqueda usa solo el catálogo local.</p>' +
      '<div id="food-search-results">' + renderSearchResults() + '</div>' +
      '<div id="food-search-selected">' + (selectedCatalogFood ? renderCatalogAddForm(selectedCatalogFood) : "") + '</div>' +
    '</section>';
}

function renderSearchResults() {
  if (catalogSearch.loading) {
    return "<p class=\"muted\" role=\"status\">Buscando…</p>";
  }

  if (!catalogSearch.query || catalogSearch.query.length < 2) {
    return "";
  }

  if (catalogSearch.results.length === 0) {
    return "<p class=\"muted\">No encontramos coincidencias. Puedes usar alimento personalizado.</p>";
  }

  return "<div class=\"search-results\">" + catalogSearch.results.map((food) =>
    "<button class=\"search-result\" type=\"button\" data-action=\"select-catalog\" data-food-key=\"" + food.food_key + "\">" +
      "<span><strong>" + escapeHtml(food.display_name) + "</strong><br><small>" + escapeHtml(food.supported_units.join(", ")) + " · " + escapeHtml(food.nutrition_source) + "</small></span>" +
      "<span>Agregar</span>" +
    "</button>",
  ).join("") + "</div>";
}

function renderCatalogAddForm(food) {
  const values = createCatalogAddValues(food);
  const unitOptions = (food.supported_units || [food.default_unit || "g"]).map((unit) =>
    "<option value=\"" + unit + "\" " + (unit === values.unit ? "selected" : "") + ">" + unit + "</option>",
  ).join("");

  return "" +
    "<form class=\"form-grid\" data-form=\"catalog\">" +
      "<h4>Agregar " + escapeHtml(food.display_name) + "</h4>" +
      "<label>Cantidad<input name=\"quantity\" type=\"number\" min=\"0.1\" step=\"0.1\" value=\"" + escapeHtml(values.quantity) + "\" required /></label>" +
      "<label>Unidad<select name=\"unit\">" + unitOptions + "</select></label>" +
      "<label>Peso en gramos opcional<input name=\"weight_g\" type=\"number\" min=\"0.1\" step=\"0.1\" placeholder=\"Ejemplo: 180\" value=\"" + escapeHtml(values.weight_g) + "\" /></label>" +
      "<label>Preparación opcional<input name=\"preparation\" placeholder=\"Ejemplo: a la plancha\" value=\"" + escapeHtml(values.preparation) + "\" /></label>" +
      "<button class=\"btn btn--dark\" type=\"submit\">Agregar y recalcular</button>" +
    "</form>";
}

function createCatalogAddValues(food) {
  const supportedUnits = food?.supported_units || [food?.default_unit || "g"];

  return {
    quantity: catalogAddDraft.quantity ?? "100",
    unit: catalogAddDraft.unit || food?.default_unit || supportedUnits[0] || "g",
    weight_g: catalogAddDraft.weight_g ?? "",
    preparation: catalogAddDraft.preparation ?? "",
  };
}

function renderManualFoodForm() {
  const values = {
    name: manualFoodDraft.name ?? "",
    quantity_label: manualFoodDraft.quantity_label ?? "",
    calories: manualFoodDraft.calories ?? "",
    protein_g: manualFoodDraft.protein_g ?? "",
    carbs_g: manualFoodDraft.carbs_g ?? "",
    fat_g: manualFoodDraft.fat_g ?? "",
  };

  return "" +
    '<section class="card support-card support-card--manual" id="manual-food">' +
      '<div class="eyebrow">Modo manual</div>' +
      '<h3>Agregar alimento personalizado</h3>' +
      '<p class="muted">Los datos manuales serán usados para esta porción completa.</p>' +
      '<form class="form-grid" data-form="manual">' +
        '<label>Nombre<input name="name" required placeholder="Ejemplo: salsa casera" value="' + escapeHtml(values.name) + '" /></label>' +
        '<label>Etiqueta de cantidad<input name="quantity_label" placeholder="Ejemplo: 2 cucharadas" value="' + escapeHtml(values.quantity_label) + '" /></label>' +
        '<label>Calorías<input name="calories" type="number" min="0" max="5000" step="1" required value="' + escapeHtml(values.calories) + '" /></label>' +
        '<label>Proteína (g)<input name="protein_g" type="number" min="0" max="500" step="0.1" required value="' + escapeHtml(values.protein_g) + '" /></label>' +
        '<label>Carbohidratos (g)<input name="carbs_g" type="number" min="0" max="1000" step="0.1" required value="' + escapeHtml(values.carbs_g) + '" /></label>' +
        '<label>Grasas (g)<input name="fat_g" type="number" min="0" max="500" step="0.1" required value="' + escapeHtml(values.fat_g) + '" /></label>' +
        '<button class="btn btn--dark" type="submit">Agregar alimento personalizado</button>' +
      '</form>' +
    '</section>';
}

function renderFinalResult() {
  const reading = createCurrentRoyalReading();

  return "" +
    '<section class="section" id="result">' +
      '<div class="grid final-result-flow">' +
        renderTotalsPanel({ title: "Resultado nutricional final", headingTag: "h2", eyebrow: "RESULTADO FINAL" }) +
        renderConfirmedMealTypeSection() +
        renderRoyalReadingCard(reading) +
        renderCurrentRoyalProductRecommendation(reading) +
        renderConfirmedEditAccordion() +
      '</div>' +
    '</section>';
}

function renderConfirmedMealTypeSection() {
  if (!state.manualMode) {
    return "";
  }

  return renderMealTypeSelector({
    id: "final-meal-type",
    value: state.mealType,
    className: "card manual-meal-type-card",
  });
}

function renderConfirmedEditAccordion() {
  const expanded = editFoodsOpen;
  const contentId = "edit-foods-content";

  return "" +
    '<section class="card edit-foods-accordion ' + (expanded ? 'is-open' : 'is-collapsed') + '" id="edit-foods-accordion">' +
      '<button class="edit-foods-trigger" type="button" data-action="toggle-edit-foods" aria-expanded="' + String(expanded) + '" aria-controls="' + contentId + '">' +
        '<span>' +
          '<span class="eyebrow">EDICIÓN</span>' +
          '<strong>' + escapeHtml(UI_TEXT.actions.editFoods) + '</strong>' +
          '<small>Abre este bloque si quieres corregir gramos, porciones o ingredientes. Al guardar cambios, volverás a confirmar la Lectura Royal.</small>' +
        '</span>' +
        '<span class="fine-tune-trigger__icon" aria-hidden="true">' + (expanded ? '−' : '+') + '</span>' +
      '</button>' +
      (expanded ? '<div class="edit-foods-content" id="' + contentId + '">' + renderReviewSummary() + renderFoodItems() + renderFineTuneAccordion() + renderManualAddSection() + '</div>' : '') +
    '</section>';
}





function renderBreakdown() {
  return "" +
    "<section class=\"card\">" +
      "<h3>Desglose por alimento</h3>" +
      "<div class=\"table-wrap\">" +
        "<table class=\"breakdown\">" +
          "<thead><tr><th>Alimento</th><th>Peso</th><th>Calorías</th><th>Proteína</th><th>Carbs</th><th>Grasas</th></tr></thead>" +
          "<tbody>" + state.calculatedItems.map((item) =>
            "<tr><td>" + escapeHtml(item.name) + "</td><td>" + (item.weight_g ? formatNumber(item.weight_g, 1) + " g" : "—") + "</td><td>" + formatCalories(item.calories) + "</td><td>" + formatMacro(item.protein_g) + "</td><td>" + formatMacro(item.carbs_g) + "</td><td>" + formatMacro(item.fat_g) + "</td></tr>",
          ).join("") + "</tbody>" +
        "</table>" +
      "</div>" +
    "</section>";
}



function formatFoodCategory(category) {
  return category ? String(category).replace(/_/g, " ") : "Catálogo Royal";
}

function renderEditIdentitySection(values, item) {
  const searchOpen = editModal?.foodSearch?.open === true || !values.food_key;
  const isPending = !values.food_key || item.needs_confirmation === true || item.nutrition_match === "not_found";
  const selectedFoodName = editModal?.selectedCatalogFood?.displayName;

  if (!searchOpen) {
    return `
      <section class="edit-identity-card" aria-label="Identidad nutricional">
        <div>
          <span class="eyebrow">Alimento del catálogo</span>
          <strong>${escapeHtml(values.name || item.name || "Alimento")}</strong>
          <small>${escapeHtml(values.food_key)} · ${escapeHtml(values.nutrition_source || "Base Royal local")}</small>
        </div>
        <button class="btn btn--ghost btn--compact" type="button" data-action="edit-change-food">Cambiar alimento</button>
      </section>`;
  }

  const helpText = isPending
    ? PENDING_FOOD_SEARCH_MESSAGE
    : "Busca otro alimento si quieres cambiar la identidad nutricional.";
  const query = editModal?.foodSearch?.query ?? "";

  return `
    <section class="edit-food-search" aria-label="Buscar alimento correcto">
      <span class="eyebrow">Identidad nutricional</span>
      <p class="muted">${escapeHtml(helpText)}</p>
      <label>Buscar en el catálogo Royal
        <input
          id="edit-food-search"
          value="${escapeHtml(query)}"
          placeholder="Ejemplo: chile serrano, huevo, tortilla"
          autocomplete="off"
          role="combobox"
          aria-expanded="${String((editModal?.foodSearch?.results || []).length > 0)}"
          aria-controls="edit-food-search-results"
          ${editModal?.isSaving ? "disabled" : ""}
        />
      </label>
      <div id="edit-food-search-results">${renderEditFoodSearchResults()}</div>
      ${selectedFoodName ? '<p class="edit-selected-message" role="status">✓ ' + escapeHtml(selectedFoodName) + ' seleccionado</p>' : ''}
    </section>`;
}

function renderEditFoodSearchResults() {
  const foodSearch = editModal?.foodSearch || { query: "", results: [], loading: false };

  if (foodSearch.loading) {
    return '<p class="muted" role="status">Buscando…</p>';
  }

  if (!foodSearch.query || foodSearch.query.length < 2) {
    return '<p class="muted">Escribe al menos dos caracteres.</p>';
  }

  if (!foodSearch.results?.length) {
    return '<p class="muted">No encontramos coincidencias en el catálogo.</p>';
  }

  const selectedFoodKey = editModal?.selectedCatalogFood?.foodKey;

  return '<div class="search-results search-results--modal">' + foodSearch.results.map((food) => {
    const selected = selectedFoodKey === food.food_key;

    return '<button class="search-result' + (selected ? ' search-result--selected' : '') + '" type="button" data-action="select-edit-food" data-food-key="' + escapeHtml(food.food_key) + '" aria-pressed="' + String(selected) + '">' +
      '<span><strong>' + escapeHtml(food.display_name) + '</strong><br><small>' +
        escapeHtml(formatFoodCategory(food.category)) + ' · ' +
        escapeHtml((food.supported_units || ["g"]).join(", ")) +
      '</small></span>' +
      '<span>' + (selected ? '✓ Seleccionado' : 'Seleccionar') + '</span>' +
    '</button>';
  }).join("") + '</div>';
}

function renderEditUnitField(values, disabled) {
  const supportedUnits = values.supported_units?.length ? values.supported_units : ["g", values.unit].filter(Boolean);
  const uniqueUnits = [...new Set(supportedUnits)];
  const hasCurrentUnit = uniqueUnits.includes(values.unit);
  const unitOptions = (hasCurrentUnit ? uniqueUnits : [values.unit, ...uniqueUnits])
    .filter(Boolean)
    .map((unit) => `<option value="${escapeHtml(unit)}" ${unit === values.unit ? "selected" : ""}>${escapeHtml(unit)}</option>`)
    .join("");

  return `<label>Unidad<select name="unit" ${disabled}>${unitOptions}</select></label>`;
}

function renderEditPortionNote(values) {
  if (values.unit === "g" || hasKnownPortionConversion(values)) {
    return "";
  }

  return '<p class="muted portion-note" role="note">Esta porción puede variar. Ajusta los gramos para mayor precisión.</p>';
}

function renderModal() {
  if (!editModal?.itemId) return "";
  const item = state.calculatedItems.find((entry) => entry.id === editModal.itemId);
  if (!item) return "";

  const values = editModal.values || createEditValues(item);
  const disabled = editModal.isSaving ? "disabled" : "";
  const buttonText = editModal.isSaving ? "Guardando…" : "Guardar y recalcular";
  const confidenceOptions = ["high", "medium", "low"].map((value) =>
    `<option value="${value}" ${values.portion_confidence === value ? "selected" : ""}>${confidenceLabel("portion", value)}</option>`,
  ).join("");
  const modalError = editModal.error
    ? `<div class="error-box" role="alert" aria-live="assertive"><strong>No pudimos recalcular</strong><p>${escapeHtml(editModal.error)}</p></div>`
    : "";

  return `
    <div class="modal-backdrop" role="presentation" data-modal-backdrop>
      <section class="modal" role="dialog" aria-modal="true" aria-labelledby="edit-title" data-modal>
        <h2 id="edit-title">Editar alimento</h2>
        ${modalError}
        ${renderEditIdentitySection(values, item)}
        <form class="form-grid" data-form="edit">
          <input type="hidden" name="food_key" value="${escapeHtml(values.food_key || "")}" />
          <input type="hidden" name="source" value="${escapeHtml(values.source || item.source || "detected")}" />
          <input type="hidden" name="nutrition_source" value="${escapeHtml(values.nutrition_source || "")}" />
          <input type="hidden" name="nutrition_match" value="${escapeHtml(values.nutrition_match || "")}" />
          <input type="hidden" name="category" value="${escapeHtml(values.category || "")}" />
          <label>Nombre visible<input name="name" value="${escapeHtml(values.name)}" required ${disabled} /></label>
          <label>Cantidad<input name="quantity" type="number" min="0.1" step="0.1" value="${escapeHtml(values.quantity)}" required ${disabled} /></label>
          ${renderEditUnitField(values, disabled)}
          <label>Peso en gramos<input name="weight_g" type="number" min="0.1" step="0.1" value="${escapeHtml(values.weight_g)}" ${disabled} /></label>
          ${renderEditPortionNote(values)}
          <label>Preparación<input name="preparation" value="${escapeHtml(values.preparation)}" ${disabled} /></label>
          <label>Confianza de porción<select name="portion_confidence" ${disabled}>${confidenceOptions}</select></label>
          <p class="muted">Los macros se recalculan con la base nutricional local. Cambiar el nombre visible no cambia la identidad nutricional sin seleccionar un alimento del catálogo.</p>
          <div class="btn-row"><button class="btn btn--dark" type="submit" ${disabled}>${buttonText}</button><button class="btn btn--ghost" type="button" data-action="close-modal" ${disabled}>Cancelar</button></div>
        </form>
      </section>
    </div>`;
}

async function handleSelectedFile(file) {
  const validation = validateImage(file);
  if (!validation.valid) {
    setError({ code: validation.code, message: validation.message });
    return;
  }

  try {
    clearError();
    mealTypeError = null;
    setState({ loading: true });
    const compressedFile = await compressImage(file);
    if (activePreviewUrl) revokePreview(activePreviewUrl);
    activePreviewUrl = createPreview(compressedFile);
    setState({
      compressedFile,
      imagePreview: activePreviewUrl,
      currentScreen: "preview",
      resultStatus: "draft",
      manualMode: false,
      loading: false,
    });
  } catch (error) {
    setError(error);
  }
}

async function runAnalysis() {
  if (analyzing || !state.compressedFile) return;
  const usage = getUsageStatus(localStorage, Date.now(), dailyScanLimit);

  if (usage.isLimitReached) {
    setState({
      ...createManualModeState({
        imagePreview: state.imagePreview,
        compressedFile: state.compressedFile,
        mealType: state.mealType,
      }),
      error: null,
    });
    return;
  }

  analyzing = true;
  clearError();
  startScanMessages();
  setState({ loading: true });

  try {
    const payload = await analyzeMeal({
      imageFile: state.compressedFile,
      mealType: state.mealType || undefined,
    });
    incrementSuccessfulScan(localStorage, Date.now(), dailyScanLimit);
    mealTypeError = null;
    fineTuneOpen = false;
    missingFoodsOpen = false;
    missingFoodsMode = "catalog";
    editFoodsOpen = false;
    stopScanMessages();
    analyzing = false;
    setState({ ...normalizeAnalyzeResponse(payload), loading: false, error: null });
    app.querySelector("#review")?.scrollIntoView({ behavior: "smooth", block: "start" });
  } catch (error) {
    stopScanMessages();
    analyzing = false;
    if (error?.code === "CLIENT_DAILY_LIMIT") {
      markUsageLimitReached(localStorage, Date.now(), dailyScanLimit, error.nextResetAt);
    }
    setError(error);
  }
}

async function updateItemsAndRecalculate(nextItems) {
  const calculationItems = toCalculationItems(nextItems);

  if (calculationItems.length === 0) {
    setState({
      calculatedItems: nextItems,
      detectedItems: nextItems,
      totals: {
        calories: 0,
        protein_g: 0,
        carbs_g: 0,
        fat_g: 0,
        items_calculated: 0,
        items_pending: nextItems.length,
        totals_complete: nextItems.length === 0,
      },
      estimatedRange: {
        calories_min: 0,
        calories_max: 0,
        range_complete: nextItems.length === 0,
      },
      currentScreen: "manual",
      resultStatus: "draft",
    });
    return;
  }

  try {
    clearError();
    setState({ loading: true });
    const result = await calculateMeal(calculationItems);
    const merged = mergeCalculationResult(nextItems, result);
    setState({
      calculatedItems: merged.items,
      detectedItems: merged.items,
      totals: merged.totals,
      estimatedRange: merged.estimatedRange,
      warnings: merged.warnings,
      loading: false,
      currentScreen: "review",
      resultStatus: "draft",
      error: null,
    });
  } catch (error) {
    setError(error);
  }
}

function formDataObject(form) {
  return Object.fromEntries(new FormData(form).entries());
}

function updateEditFormValues(editForm, changedField = null) {
  const nextValues = syncEditPortionValues(
    {
      ...(editModal?.values || {}),
      ...formDataObject(editForm),
    },
    changedField,
  );

  editModal = {
    ...editModal,
    values: nextValues,
    error: null,
  };

  if (changedField === "quantity" || changedField === "unit") {
    const weightInput = editForm.querySelector('[name="weight_g"]');
    if (weightInput && document.activeElement !== weightInput) {
      weightInput.value = nextValues.weight_g ?? "";
    }
  }

  if (changedField === "weight_g") {
    const quantityInput = editForm.querySelector('[name="quantity"]');
    if (quantityInput && document.activeElement !== quantityInput) {
      quantityInput.value = nextValues.quantity ?? "";
    }
  }

  return nextValues;
}

function updateCatalogSearchPanels() {
  updateCatalogSearchDom({
    windowRef: window,
    resultsContainer: app.querySelector("#food-search-results"),
    selectedContainer: app.querySelector("#food-search-selected"),
    resultsHtml: renderSearchResults(),
    selectedHtml: selectedCatalogFood ? renderCatalogAddForm(selectedCatalogFood) : "",
    activeElement: document.activeElement,
  });
}

function updateEditFoodSearchPanel() {
  const scrollX = window.scrollX;
  const scrollY = window.scrollY;
  const activeElement = document.activeElement;
  const resultsContainer = app.querySelector("#edit-food-search-results");

  if (resultsContainer) {
    resultsContainer.innerHTML = renderEditFoodSearchResults();
  }

  if (activeElement?.id === "edit-food-search" && typeof activeElement.focus === "function") {
    activeElement.focus({ preventScroll: true });
  }

  if (window.scrollY !== scrollY) {
    window.scrollTo(scrollX, scrollY);
  }
}

function openEditFoodSearch() {
  if (!editModal) {
    return false;
  }

  editModal = {
    ...editModal,
    error: null,
    foodSearch: {
      open: true,
      query: editModal.foodSearch?.query || editModal.values?.name || "",
      results: editModal.foodSearch?.results || [],
      loading: false,
    },
  };
  render();
  requestAnimationFrame(() => {
    app.querySelector("#edit-food-search")?.focus({ preventScroll: true });
  });
  return true;
}

function selectEditFoodResult(foodKey) {
  if (!editModal) {
    return false;
  }

  const selectedFood = (editModal.foodSearch?.results || []).find((food) => food.food_key === foodKey);

  if (!selectedFood) {
    return false;
  }

  const scrollX = window.scrollX;
  const scrollY = window.scrollY;
  const selectedCatalogFood = createEditCatalogSelection(selectedFood);

  editModal = {
    ...editModal,
    selectedCatalogFood,
    values: applyCatalogSelectionToEditValues(editModal.values, selectedCatalogFood),
    error: null,
    foodSearch: {
      ...(editModal.foodSearch || {}),
      open: true,
      query: editModal.foodSearch?.query || selectedCatalogFood.displayName,
      results: editModal.foodSearch?.results || [],
      loading: false,
    },
  };
  render();

  if (window.scrollY !== scrollY) {
    window.scrollTo(scrollX, scrollY);
  }

  return true;
}

app.addEventListener("click", async (event) => {
  const actionElement = event.target.closest("[data-action]");
  if (!actionElement) return;
  const action = actionElement.dataset.action;

  if (action === "choose-gallery") app.querySelector("#gallery-input")?.click();
  if (action === "choose-camera") app.querySelector("#camera-input")?.click();
  if (action === "change-photo") app.querySelector("#gallery-input")?.click();
  if (action === "remove-photo") {
    if (activePreviewUrl) revokePreview(activePreviewUrl);
    activePreviewUrl = null;
    fineTuneOpen = false;
    missingFoodsOpen = false;
    editFoodsOpen = false;
    mealTypeError = null;
    setState({ imagePreview: null, compressedFile: null, currentScreen: "start", resultStatus: "draft", manualMode: false });
  }
  if (action === "meal-type") {
    const nextMealType = normalizeMealTypeValue(actionElement.dataset.mealType);
    if (nextMealType) {
      mealTypeError = null;
      setState({ mealType: nextMealType });
    }
  }
  if (action === "analyze" || action === "retry") await runAnalysis();
  if (action === "manual-mode") {
    fineTuneOpen = false;
    missingFoodsOpen = true;
    missingFoodsMode = "custom";
    mealTypeError = null;
    setState({
      ...createManualModeState({
        imagePreview: state.imagePreview,
        compressedFile: state.compressedFile,
        mealType: state.mealType,
      }),
      error: null,
    });
    scrollToElement("#manual-meal-type");
  }
  if (action === "edit-item") {
    const item = state.calculatedItems.find((entry) => entry.id === actionElement.dataset.id);
    if (item) {
      editModal = {
        itemId: item.id,
        values: createEditValues(item),
        selectedCatalogFood: null,
        foodSearch: {
          open: !item.food_key || item.nutrition_match === "not_found",
          query: !item.food_key ? item.name || "" : "",
          results: [],
          loading: false,
        },
        isSaving: false,
        error: null,
      };
      render();
      const initialQuery = editModal.foodSearch.query.trim();
      if (editModal.foodSearch.open && initialQuery.length >= 2) {
        debouncedEditFoodSearch(initialQuery).catch((error) => {
          if (!error?.cancelled) {
            editModal = failEditSave(editModal, error);
            render();
          }
        });
      }
    }
  }
  if (action === "close-modal") {
    closeEditModal();
  }
  if (action === "edit-change-food" && editModal) {
    event.preventDefault();
    openEditFoodSearch();
  }
  if (action === "toggle-fine-tune") {
    fineTuneOpen = !fineTuneOpen;
    render();
  }
  if (action === "toggle-missing-foods") {
    missingFoodsOpen = !missingFoodsOpen;
    render();
  }
  if (action === "missing-foods-mode") {
    const nextMode = actionElement.dataset.mode === "custom" ? "custom" : "catalog";
    missingFoodsOpen = true;
    missingFoodsMode = nextMode;
    render();
    requestAnimationFrame(() => {
      const selector = nextMode === "custom" ? '#manual-food input[name="name"]' : "#food-search";
      app.querySelector(selector)?.focus();
    });
  }
  if (action === "toggle-royal-goals") {
    const requestedContext = actionElement.dataset.goalsContext || "scanner";
    goalsPanelOpen = goalsPanelContext === requestedContext ? !goalsPanelOpen : true;
    goalsPanelContext = requestedContext;
    goalsFormError = null;
    render();
    if (goalsPanelOpen) scrollToElement("#royal-goals-panel-" + goalsPanelContext);
  }
  if (action === "delete-item") {
    const id = actionElement.dataset.id;
    if (window.confirm("¿Eliminar este alimento del cálculo?")) {
      await updateItemsAndRecalculate(removeItem(state.calculatedItems, id));
    }
  }
  if (action === "select-catalog") {
    event.preventDefault();
    selectedCatalogFood = catalogSearch.results.find((food) => food.food_key === actionElement.dataset.foodKey) || null;
    catalogAddDraft = {};
    updateCatalogSearchPanels();
  }
  if (action === "select-edit-food" && editModal) {
    event.preventDefault();
    selectEditFoodResult(actionElement.dataset.foodKey);
  }
  if (action === "select-hidden") {
    fineTuneOpen = true;
    selectedHiddenFoodKey = actionElement.dataset.foodKey;
    render();
    scrollToElement("#hidden-ingredient-form");
  }
  if (action === "hidden-suggestion") {
    const foodKey = actionElement.dataset.foodKey || "";
    fineTuneOpen = true;
    selectedHiddenFoodKey = HIDDEN_INGREDIENTS.some((ingredient) => ingredient.food_key === foodKey) ? foodKey : null;
    render();

    if (selectedHiddenFoodKey) {
      scrollToElement("#hidden-ingredient-form");
      requestAnimationFrame(() => app.querySelector('#hidden-ingredient-form input[name="quantity"]')?.focus());
    } else {
      scrollToElement("#fine-tune-accordion");
      requestAnimationFrame(() => app.querySelector('[data-action="focus-manual"]')?.focus());
    }
  }
  if (action === "focus-manual") {
    missingFoodsOpen = true;
    missingFoodsMode = "custom";
    render();
    scrollToElement("#missing-foods-accordion");
    requestAnimationFrame(() => app.querySelector('#manual-food input[name="name"]')?.focus());
  }
  if (action === "confirm-draft") {
    const confirmedMealType = normalizeMealTypeValue(state.mealType);
    if (!isValidMealType(confirmedMealType)) {
      mealTypeError = MEAL_TYPE_REQUIRED_MESSAGE;
      render();
      scrollToElement("#manual-meal-type");
      return;
    }

    mealTypeError = null;
    fineTuneOpen = false;
    missingFoodsOpen = false;
    editFoodsOpen = false;
    setState({ mealType: confirmedMealType, currentScreen: "final", resultStatus: "confirmed" });
    scrollToElement("#nutrition-result");
  }
  if (action === "toggle-edit-foods") {
    editFoodsOpen = !editFoodsOpen;
    render();
  }
  if (action === "continue-editing") {
    fineTuneOpen = true;
    editFoodsOpen = true;
    render();
    scrollToElement("#fine-tune-accordion");
  }
});

app.addEventListener("change", (event) => {
  const editForm = event.target.closest('form[data-form="edit"]');
  if (editForm && editModal) {
    updateEditFormValues(editForm, event.target.name);
  }

  const catalogForm = event.target.closest('form[data-form="catalog"]');
  if (catalogForm) {
    catalogAddDraft = { ...catalogAddDraft, ...formDataObject(catalogForm) };
  }

  const manualForm = event.target.closest('form[data-form="manual"]');
  if (manualForm) {
    manualFoodDraft = { ...manualFoodDraft, ...formDataObject(manualForm) };
  }

  if (event.target.matches("[data-file-input]") && event.target.files?.[0]) {
    handleSelectedFile(event.target.files[0]);
  }
});

app.addEventListener("input", (event) => {
  const editForm = event.target.closest('form[data-form="edit"]');
  if (editForm && editModal) {
    updateEditFormValues(editForm, event.target.name);
  }

  const catalogForm = event.target.closest('form[data-form="catalog"]');
  if (catalogForm) {
    catalogAddDraft = { ...catalogAddDraft, ...formDataObject(catalogForm) };
  }

  const manualForm = event.target.closest('form[data-form="manual"]');
  if (manualForm) {
    manualFoodDraft = { ...manualFoodDraft, ...formDataObject(manualForm) };
  }

  if (event.target.id === "food-search") {
    const query = event.target.value.trim();
    selectedCatalogFood = null;

    if (query.length < 2) {
      catalogSearch = { query, results: [], loading: false };
      updateCatalogSearchPanels();
      return;
    }

    catalogSearch = { ...catalogSearch, query };
    debouncedCatalogSearch(query).catch((error) => {
      if (!error?.cancelled) setError(error);
    });
  }

  if (event.target.id === "edit-food-search" && editModal) {
    const query = event.target.value.trim();
    editModal = {
      ...editModal,
      foodSearch: {
        ...(editModal.foodSearch || {}),
        open: true,
        query,
        results: query.length < 2 ? [] : editModal.foodSearch?.results || [],
        loading: false,
      },
    };

    if (query.length < 2) {
      updateEditFoodSearchPanel();
      return;
    }

    debouncedEditFoodSearch(query).catch((error) => {
      if (!error?.cancelled) {
        editModal = failEditSave(editModal, error);
        render();
      }
    });
  }
});

app.addEventListener("submit", async (event) => {
  const form = event.target.closest("form[data-form]");
  if (!form) return;
  event.preventDefault();
  const values = formDataObject(form);

  if (form.dataset.form === "royal-goals") {
    const savedGoalsContext = goalsPanelContext;
    try {
      royalGoals = saveRoyalGoals(values);
      goalsPanelOpen = false;
      goalsFormError = null;
      render();
      scrollToElement(savedGoalsContext === "reading" && state.resultStatus === "confirmed" ? "#royal-reading" : "#royal-goals-accordion");
    } catch (error) {
      goalsPanelOpen = true;
      goalsFormError = error?.message || UI_TEXT.goals.invalid;
      render();
    }
    return;
  }

  if (form.dataset.form === "edit") {
    if (!canSubmitEdit(editModal)) return;
    const editValues = {
      ...(editModal.values || {}),
      ...values,
    };
    const validation = validateEditCatalogSelection(editValues, editModal.selectedCatalogFood);

    if (!validation.valid) {
      editModal = failEditSave(
        {
          ...editModal,
          values: editValues,
          isSaving: false,
          foodSearch: {
            ...(editModal.foodSearch || {}),
            open: true,
          },
        },
        new Error(validation.message),
      );
      render();
      return;
    }

    editModal = beginEditSave({ ...editModal, values: editValues });
    render();

    try {
      const merged = await saveEditedItem({
        items: state.calculatedItems,
        itemId: editModal.itemId,
        values: editModal.values,
        selectedCatalogFood: editModal.selectedCatalogFood,
        calculateMealImpl: calculateMeal,
      });
      editModal = completeEditSave();
      setState({
        calculatedItems: merged.items,
        detectedItems: merged.items,
        totals: merged.totals,
        estimatedRange: merged.estimatedRange,
        warnings: merged.warnings,
        loading: false,
        currentScreen: "review",
        resultStatus: "draft",
        error: null,
      });
    } catch (error) {
      editModal = failEditSave(editModal, error);
      render();
    }
  }

  if (form.dataset.form === "catalog" && selectedCatalogFood) {
    const nextItems = addCatalogItem(state.calculatedItems, selectedCatalogFood, values);
    selectedCatalogFood = null;
    catalogAddDraft = {};
    await updateItemsAndRecalculate(nextItems);
  }

  if (form.dataset.form === "hidden" && selectedHiddenFoodKey) {
    const nextItems = addHiddenIngredient(state.calculatedItems, selectedHiddenFoodKey, values);
    selectedHiddenFoodKey = null;
    await updateItemsAndRecalculate(nextItems);
  }

  if (form.dataset.form === "manual") {
    try {
      const nextItems = addManualItem(state.calculatedItems, values);
      manualFoodDraft = {};
      form.reset();
      await updateItemsAndRecalculate(nextItems);
    } catch (error) {
      setError(error);
    }
  }
});

const dropZoneEvents = ["dragenter", "dragover"];
const leaveZoneEvents = ["dragleave", "drop"];

dropZoneEvents.forEach((eventName) => {
  app.addEventListener(eventName, (event) => {
    if (!event.target.closest("#drop-zone")) return;
    event.preventDefault();
    event.target.closest("#drop-zone")?.classList.add("is-dragging");
  });
});

leaveZoneEvents.forEach((eventName) => {
  app.addEventListener(eventName, (event) => {
    if (!event.target.closest("#drop-zone")) return;
    event.preventDefault();
    event.target.closest("#drop-zone")?.classList.remove("is-dragging");
    if (eventName === "drop" && event.dataTransfer?.files?.[0]) {
      handleSelectedFile(event.dataTransfer.files[0]);
    }
  });
});

app.addEventListener("keydown", (event) => {
  if (event.key === "Enter" && event.target?.id === "edit-food-search") {
    event.preventDefault();
    return;
  }

  if (preventCatalogSearchEnter(event)) return;

  if (event.target.closest("#drop-zone") && (event.key === "Enter" || event.key === " ")) {
    event.preventDefault();
    app.querySelector("#gallery-input")?.click();
  }
});

document.addEventListener("keydown", (event) => {
  if (handleEditModalEscape(event, closeEditModal)) {
    event.preventDefault();
  }
});

render();
return {
  destroy() {
    stopScanMessages();
    if (activePreviewUrl) revokePreview(activePreviewUrl);
  },
};
}

exports.createRoyalFoodScannerApp = createRoyalFoodScannerApp;
},
"./api.js": function(module, exports, __require) {
const { API_BASE_URL, USE_MOCK_API } = __require("./config.js");
const { getOrCreateClientId } = __require("./client-id.js");
const { toBackendMealType } = __require("./meal-type-ui.js");

const DEFAULT_LIMIT = 10;

const ApiError = exports.ApiError = class ApiError extends Error {
  constructor({
    status = 0,
    code = "UNKNOWN_ERROR",
    message,
    manualModeAvailable = false,
    nextResetAt = null,
  } = {}) {
    super(message || "Ocurrió un error inesperado.");
    this.name = "ApiError";
    this.status = status;
    this.code = code;
    this.manualModeAvailable = manualModeAvailable;
    this.nextResetAt = nextResetAt;
  }
}

function cleanBaseUrl(baseUrl) {
  return String(baseUrl || "").replace(/\/$/, "");
}

async function parseJsonResponse(response) {
  const text = await response.text();

  if (!text) {
    return null;
  }

  try {
    return JSON.parse(text);
  } catch {
    throw new ApiError({
      status: response.status,
      code: "INVALID_API_RESPONSE",
      message: "El servidor devolvió una respuesta que no pudimos leer.",
    });
  }
}

async function requestJson(routePath, options = {}, fetchImpl = fetch, apiBaseUrl = API_BASE_URL) {
  let response;

  try {
    response = await fetchImpl(cleanBaseUrl(apiBaseUrl || API_BASE_URL) + routePath, options);
  } catch {
    throw new ApiError({
      code: "NETWORK_ERROR",
      message: "No pudimos conectar con el backend local. Revisa que Wrangler siga abierto.",
      manualModeAvailable: true,
    });
  }

  const body = await parseJsonResponse(response);

  if (!response.ok || body?.success === false) {
    throw new ApiError({
      status: response.status,
      code: body?.code || "API_ERROR",
      message: body?.message || "El backend no pudo completar la solicitud.",
      manualModeAvailable: body?.manual_mode_available === true,
      nextResetAt: body?.nextResetAt ?? null,
    });
  }

  return body;
}

function buildAnalyzeFormData({ imageFile, mealType, notes, clientId }) {
  const formData = new FormData();
  formData.append("image", imageFile);

  const backendMealType = toBackendMealType(mealType);
  if (backendMealType) {
    formData.append("mealType", backendMealType);
  }

  if (notes) {
    formData.append("notes", notes);
  }

  if (clientId) {
    formData.append("clientId", clientId);
  }

  return formData;
}

async function analyzeMeal(params, options = {}) {
  if (USE_MOCK_API) {
    return mockAnalyzeMeal();
  }

  const clientId = options.clientId ?? getOrCreateClientId();

  return requestJson(
    "/analyze-meal",
    {
      method: "POST",
      body: buildAnalyzeFormData({ ...params, clientId }),
    },
    options.fetchImpl,
    options.apiBaseUrl,
  );
}

async function searchFoods(query, options = {}) {
  const trimmedQuery = String(query || "").trim();
  const limit = options.limit || DEFAULT_LIMIT;

  if (trimmedQuery.length < 2) {
    return { success: true, query: trimmedQuery, items: [] };
  }

  if (USE_MOCK_API) {
    return mockSearchFoods(trimmedQuery, limit);
  }

  const params = new URLSearchParams({ query: trimmedQuery, limit: String(limit) });
  return requestJson("/foods?" + params.toString(), {}, options.fetchImpl, options.apiBaseUrl);
}

async function calculateMeal(items, options = {}) {
  if (USE_MOCK_API) {
    return mockCalculateMeal(items);
  }

  return requestJson(
    "/calculate-meal",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items }),
    },
    options.fetchImpl,
    options.apiBaseUrl,
  );
}

const MOCK_FOODS = [
  {
    food_key: "chicken_breast_cooked",
    display_name: "Pechuga de pollo cocida",
    category: "poultry",
    default_unit: "g",
    supported_units: ["g", "porción"],
    portion_grams: { "porción": 100 },
    nutrition_source: "Base Royal local",
  },
  {
    food_key: "white_rice_cooked",
    display_name: "Arroz blanco cocido",
    category: "grain",
    default_unit: "g",
    supported_units: ["g", "taza"],
    portion_grams: { taza: 158 },
    nutrition_source: "Base Royal local",
  },
  {
    food_key: "cooking_oil",
    display_name: "Aceite de cocina",
    category: "fat",
    default_unit: "cucharada",
    supported_units: ["g", "cucharadita", "cucharada"],
    portion_grams: { cucharadita: 4.5, cucharada: 13.5 },
    nutrition_source: "Base Royal local",
  },
  {
    food_key: "whole_egg_cooked",
    display_name: "Huevo entero cocido",
    category: "egg",
    default_unit: "pieza",
    supported_units: ["g", "pieza", "piezas"],
    portion_grams: { pieza: 50, piezas: 50 },
    nutrition_source: "Base Royal local",
  },
  {
    food_key: "serrano_pepper_raw",
    display_name: "Chile serrano",
    category: "vegetable",
    default_unit: "g",
    supported_units: ["g", "pieza", "piezas"],
    portion_grams: { pieza: 6, piezas: 6 },
    nutrition_source: "Base Royal local",
  },
];

function nutritionForMockItem(item) {
  if (item.source === "manual_nutrition") {
    return {
      calories: Math.round(item.manual_nutrition.calories),
      protein_g: round1(item.manual_nutrition.protein_g),
      carbs_g: round1(item.manual_nutrition.carbs_g),
      fat_g: round1(item.manual_nutrition.fat_g),
      weight_g: item.weight_g ?? null,
      nutrition_source: "Manual",
      nutrition_match: "manual",
    };
  }

  const grams = Number(item.weight_g || item.quantity || 100);
  const per100 = {
    chicken_breast_cooked: { calories: 165, protein_g: 31, carbs_g: 0, fat_g: 3.6 },
    white_rice_cooked: { calories: 130, protein_g: 2.7, carbs_g: 28.2, fat_g: 0.3 },
    cooking_oil: { calories: 884, protein_g: 0, carbs_g: 0, fat_g: 100 },
    olive_oil: { calories: 884, protein_g: 0, carbs_g: 0, fat_g: 100 },
    butter: { calories: 717, protein_g: 0.9, carbs_g: 0.1, fat_g: 81.1 },
    mayonnaise: { calories: 680, protein_g: 1, carbs_g: 0.6, fat_g: 75 },
    sugar: { calories: 387, protein_g: 0, carbs_g: 100, fat_g: 0 },
    vinaigrette_dressing: { calories: 290, protein_g: 0.4, carbs_g: 6, fat_g: 30 },
    creamy_dressing: { calories: 430, protein_g: 1, carbs_g: 9, fat_g: 43 },
    cream: { calories: 340, protein_g: 2.1, carbs_g: 2.8, fat_g: 36 },
    cheese_generic: { calories: 402, protein_g: 25, carbs_g: 1.3, fat_g: 33 },
    whole_egg_cooked: { calories: 155, protein_g: 12.6, carbs_g: 1.1, fat_g: 10.6 },
    serrano_pepper_raw: { calories: 32, protein_g: 1.74, carbs_g: 6.7, fat_g: 0.44 },
  }[item.food_key] || { calories: 100, protein_g: 5, carbs_g: 10, fat_g: 3 };

  const factor = grams / 100;

  return {
    calories: Math.round(per100.calories * factor),
    protein_g: round1(per100.protein_g * factor),
    carbs_g: round1(per100.carbs_g * factor),
    fat_g: round1(per100.fat_g * factor),
    weight_g: round1(grams),
    nutrition_source: "Demo local",
    nutrition_match: "exact",
  };
}

function round1(value) {
  return Math.round((Number(value) + Number.EPSILON) * 10) / 10;
}

function mockAnalyzeMeal() {
  const detected_items = [
    {
      id: "item_1",
      food_key: "chicken_breast_cooked",
      name: "Pechuga de pollo",
      canonical_name: "chicken_breast_cooked",
      preparation: "a la plancha",
      estimated_quantity: 180,
      quantity: 180,
      unit: "g",
      estimated_weight_g: 180,
      weight_g: 180,
      identity_confidence: "high",
      portion_confidence: "medium",
      visible: true,
      needs_confirmation: false,
      source: "detected",
      nutrition_source: "Demo local",
      ...nutritionForMockItem({ food_key: "chicken_breast_cooked", quantity: 180, weight_g: 180 }),
    },
    {
      id: "item_2",
      food_key: "white_rice_cooked",
      name: "Arroz blanco",
      canonical_name: "white_rice_cooked",
      preparation: "cocido",
      estimated_quantity: 160,
      quantity: 160,
      unit: "g",
      estimated_weight_g: 160,
      weight_g: 160,
      identity_confidence: "medium",
      portion_confidence: "medium",
      visible: true,
      needs_confirmation: true,
      source: "detected",
      nutrition_source: "Demo local",
      ...nutritionForMockItem({ food_key: "white_rice_cooked", quantity: 160, weight_g: 160 }),
    },
  ];
  const totals = totalMockItems(detected_items);

  return Promise.resolve({
    success: true,
    meal_summary: "Plato con pollo y arroz.",
    analysis_confidence: "medium",
    detected_items,
    possible_hidden_ingredients: ["aceite de cocción", "aderezo"],
    clarifying_questions: ["¿Se cocinó con aceite o mantequilla?"],
    warnings: ["Revisa la porción de arroz antes de confirmar."],
    totals,
    estimated_range: {
      calories_min: Math.round(totals.calories * 0.8),
      calories_max: Math.round(totals.calories * 1.2),
      range_complete: true,
    },
    range_complete: true,
  });
}

function mockSearchFoods(query, limit) {
  const normalized = query.toLowerCase();
  const items = MOCK_FOODS.filter((food) =>
    food.display_name.toLowerCase().includes(normalized) ||
    food.food_key.toLowerCase().includes(normalized),
  ).slice(0, limit);

  return Promise.resolve({ success: true, query, items });
}

function totalMockItems(items) {
  const totals = items.reduce(
    (sum, item) => ({
      calories: sum.calories + Number(item.calories || 0),
      protein_g: sum.protein_g + Number(item.protein_g || 0),
      carbs_g: sum.carbs_g + Number(item.carbs_g || 0),
      fat_g: sum.fat_g + Number(item.fat_g || 0),
    }),
    { calories: 0, protein_g: 0, carbs_g: 0, fat_g: 0 },
  );

  return {
    calories: Math.round(totals.calories),
    protein_g: round1(totals.protein_g),
    carbs_g: round1(totals.carbs_g),
    fat_g: round1(totals.fat_g),
    items_calculated: items.length,
    items_pending: 0,
    totals_complete: true,
  };
}

function mockCalculateMeal(items) {
  const calculatedItems = items.map((item) => {
    const nutrition = nutritionForMockItem(item);
    return {
      id: item.id,
      food_key: item.food_key ?? null,
      name: item.name,
      quantity: item.quantity,
      unit: item.unit,
      weight_g: nutrition.weight_g,
      source: item.source,
      ...nutrition,
      portion_confidence: item.portion_confidence || "medium",
    };
  });
  const totals = totalMockItems(calculatedItems);

  return Promise.resolve({
    success: true,
    items: calculatedItems,
    totals,
    estimated_range: {
      calories_min: Math.round(totals.calories * 0.8),
      calories_max: Math.round(totals.calories * 1.2),
      range_complete: true,
    },
    warnings: [],
  });
}

exports.analyzeMeal = analyzeMeal;
exports.searchFoods = searchFoods;
exports.calculateMeal = calculateMeal;
exports.buildAnalyzeFormData = buildAnalyzeFormData;
},
"./config.js": function(module, exports, __require) {
const env = {};

const API_BASE_URL = exports.API_BASE_URL = "https://royal-food-scan-api.royal-athletes-tools.workers.dev";

const USE_MOCK_API = exports.USE_MOCK_API = false;

const PRODUCT_LINKS = exports.PRODUCT_LINKS = {
  isoGold: "#",
  womenProtein: "#",
  platinum: "#",
  recommendedProtein: "#",
};

const ROYAL_LINKS = exports.ROYAL_LINKS = {
  diagnostic: "#",
  guide: "#",
  calculator: "#",
};

},
"./client-id.js": function(module, exports, __require) {
const CLIENT_ID_STORAGE_KEY = "royal_food_scan_client_id_v1";
const CLIENT_ID_PATTERN = /^[A-Za-z0-9_-]{16,128}$/;

let memoryClientId = null;

function isValidClientId(value) {
  return typeof value === "string" && CLIENT_ID_PATTERN.test(value);
}

function bytesToBase64Url(bytes) {
  let binary = "";

  for (const byte of bytes) {
    binary += String.fromCharCode(byte);
  }

  return btoa(binary).replaceAll("+", "-").replaceAll("/", "_").replaceAll("=", "");
}

function createClientId(cryptoRef = globalThis.crypto) {
  if (typeof cryptoRef?.randomUUID === "function") {
    return cryptoRef.randomUUID();
  }

  const bytes = new Uint8Array(24);

  if (typeof cryptoRef?.getRandomValues === "function") {
    cryptoRef.getRandomValues(bytes);
  } else {
    for (let index = 0; index < bytes.length; index += 1) {
      bytes[index] = Math.floor(Math.random() * 256);
    }
  }

  return "royal_" + bytesToBase64Url(bytes);
}

function getOrCreateClientId(
  storage = globalThis.localStorage,
  cryptoRef = globalThis.crypto,
) {
  try {
    const existing = storage?.getItem(CLIENT_ID_STORAGE_KEY);

    if (isValidClientId(existing)) {
      return existing;
    }

    const nextId = createClientId(cryptoRef);
    storage?.setItem(CLIENT_ID_STORAGE_KEY, nextId);
    return nextId;
  } catch {
    if (!isValidClientId(memoryClientId)) {
      memoryClientId = createClientId(cryptoRef);
    }

    return memoryClientId;
  }
}

exports.isValidClientId = isValidClientId;
exports.createClientId = createClientId;
exports.getOrCreateClientId = getOrCreateClientId;
},
"./meal-type-ui.js": function(module, exports, __require) {
const MEAL_TYPE_OPTIONS = exports.MEAL_TYPE_OPTIONS = Object.freeze([
  Object.freeze({ value: "breakfast", label: "Desayuno", backendValue: "desayuno" }),
  Object.freeze({ value: "lunch", label: "Comida", backendValue: "comida" }),
  Object.freeze({ value: "dinner", label: "Cena", backendValue: "cena" }),
  Object.freeze({ value: "snack", label: "Snack", backendValue: "snack" }),
  Object.freeze({ value: "other", label: "Otro", backendValue: "otro" }),
]);

const MEAL_TYPE_REQUIRED_MESSAGE = exports.MEAL_TYPE_REQUIRED_MESSAGE = "Selecciona el tipo de comida para obtener una Lectura Royal más precisa.";

const MEAL_TYPE_ALIASES = Object.freeze({
  breakfast: "breakfast",
  desayuno: "breakfast",
  lunch: "lunch",
  comida: "lunch",
  dinner: "dinner",
  cena: "dinner",
  snack: "snack",
  other: "other",
  otro: "other",
});

function escapeAttribute(value) {
  return String(value ?? "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#039;");
}

function normalizeMealTypeValue(value) {
  return MEAL_TYPE_ALIASES[String(value || "").trim().toLowerCase()] || "";
}

function isValidMealType(value) {
  return normalizeMealTypeValue(value) !== "";
}

function toBackendMealType(value) {
  const normalized = normalizeMealTypeValue(value);
  return MEAL_TYPE_OPTIONS.find((option) => option.value === normalized)?.backendValue || "";
}

function renderMealTypeSelector({
  value = "",
  id = "meal-type-selector",
  title = "Tipo de comida",
  description = "Selecciona una opción para personalizar tu Lectura Royal.",
  error = "",
  className = "",
} = {}) {
  const normalizedValue = normalizeMealTypeValue(value);
  const safeId = escapeAttribute(id);
  const errorId = safeId + "-error";
  const describedBy = error ? ' aria-describedby="' + errorId + '"' : "";
  const classes = ["meal-type-selector", className].filter(Boolean).join(" ");

  return "" +
    '<section class="' + escapeAttribute(classes) + '" id="' + safeId + '">' +
      '<h3>' + escapeAttribute(title) + '</h3>' +
      '<p class="muted">' + escapeAttribute(description) + '</p>' +
      '<div class="chips" role="group" aria-label="Tipo de comida"' + describedBy + '>' +
        MEAL_TYPE_OPTIONS.map((option) =>
          '<button class="chip" type="button" data-action="meal-type" data-meal-type="' + option.value + '" aria-pressed="' + String(normalizedValue === option.value) + '">' +
            escapeAttribute(option.label) +
          '</button>',
        ).join("") +
      '</div>' +
      (error ? '<p class="meal-type-selector__error" id="' + errorId + '" role="alert">' + escapeAttribute(error) + '</p>' : "") +
    '</section>';
}

exports.normalizeMealTypeValue = normalizeMealTypeValue;
exports.isValidMealType = isValidMealType;
exports.toBackendMealType = toBackendMealType;
exports.renderMealTypeSelector = renderMealTypeSelector;
},
"./image-utils.js": function(module, exports, __require) {
const ACCEPTED_IMAGE_TYPES = exports.ACCEPTED_IMAGE_TYPES = new Set([
  "image/jpeg",
  "image/png",
  "image/webp",
]);

const MAX_SOURCE_IMAGE_BYTES = exports.MAX_SOURCE_IMAGE_BYTES = 10 * 1024 * 1024;
const TARGET_IMAGE_BYTES = exports.TARGET_IMAGE_BYTES = 1.5 * 1024 * 1024;
const MAX_IMAGE_SIDE = exports.MAX_IMAGE_SIDE = 1600;
const JPEG_QUALITY = exports.JPEG_QUALITY = 0.82;

const ImageValidationError = exports.ImageValidationError = class ImageValidationError extends Error {
  constructor(code, message) {
    super(message);
    this.name = "ImageValidationError";
    this.code = code;
  }
}

function validateImage(file, options = {}) {
  const maxBytes = options.maxBytes ?? MAX_SOURCE_IMAGE_BYTES;

  if (!file) {
    return {
      valid: false,
      code: "IMAGE_REQUIRED",
      message: "Selecciona una fotografía de tu comida.",
    };
  }

  if (!ACCEPTED_IMAGE_TYPES.has(file.type)) {
    return {
      valid: false,
      code: "INVALID_IMAGE_TYPE",
      message: "Usa una imagen JPG, PNG o WEBP.",
    };
  }

  if (!Number.isFinite(file.size) || file.size <= 0) {
    return {
      valid: false,
      code: "EMPTY_IMAGE",
      message: "La fotografía está vacía.",
    };
  }

  if (file.size > maxBytes) {
    return {
      valid: false,
      code: "IMAGE_TOO_LARGE",
      message: "La fotografía es demasiado pesada. Prueba con una imagen más ligera.",
    };
  }

  return { valid: true, code: null, message: "" };
}

function loadImage(url) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = () => reject(new ImageValidationError("INVALID_IMAGE", "No pudimos leer la fotografía."));
    image.src = url;
  });
}

function getTargetSize(width, height, maxSide) {
  const ratio = Math.min(1, maxSide / Math.max(width, height));
  return {
    width: Math.max(1, Math.round(width * ratio)),
    height: Math.max(1, Math.round(height * ratio)),
  };
}

function canvasToBlob(canvas, type, quality) {
  return new Promise((resolve) => {
    canvas.toBlob(resolve, type, quality);
  });
}

async function compressImage(file, options = {}) {
  const validation = validateImage(file, { maxBytes: options.maxSourceBytes ?? MAX_SOURCE_IMAGE_BYTES });

  if (!validation.valid) {
    throw new ImageValidationError(validation.code, validation.message);
  }

  const targetBytes = options.targetBytes ?? TARGET_IMAGE_BYTES;

  if (typeof document === "undefined" || typeof Image === "undefined" || typeof URL === "undefined") {
    if (file.size <= targetBytes) {
      return file;
    }

    throw new ImageValidationError(
      "IMAGE_TOO_LARGE",
      "La imagen debe pesar menos de 1.5 MB después de comprimirse.",
    );
  }

  const objectUrl = URL.createObjectURL(file);

  try {
    const image = await loadImage(objectUrl);
    const size = getTargetSize(image.naturalWidth || image.width, image.naturalHeight || image.height, options.maxSide ?? MAX_IMAGE_SIDE);
    const canvas = document.createElement("canvas");
    canvas.width = size.width;
    canvas.height = size.height;
    const context = canvas.getContext("2d", { alpha: false });

    if (!context) {
      throw new ImageValidationError("IMAGE_PROCESSING_FAILED", "No pudimos preparar la imagen para enviarla.");
    }

    context.drawImage(image, 0, 0, size.width, size.height);

    let quality = options.quality ?? JPEG_QUALITY;
    let blob = null;

    while (quality >= 0.62) {
      blob = await canvasToBlob(canvas, "image/jpeg", quality);
      if (blob && blob.size <= targetBytes) {
        break;
      }
      quality -= 0.08;
    }

    if (!blob || blob.size > targetBytes) {
      throw new ImageValidationError(
        "IMAGE_TOO_LARGE",
        "La imagen sigue pesando demasiado después de comprimirla. Prueba con otra fotografía.",
      );
    }

    const fileName = String(file.name || "meal-photo").replace(/\.[^.]+$/, "") + "-royal.jpg";
    return new File([blob], fileName, { type: "image/jpeg", lastModified: Date.now() });
  } finally {
    URL.revokeObjectURL(objectUrl);
  }
}

function createPreview(file) {
  const validation = validateImage(file);

  if (!validation.valid) {
    throw new ImageValidationError(validation.code, validation.message);
  }

  return URL.createObjectURL(file);
}

function revokePreview(previewUrl) {
  if (previewUrl && typeof URL !== "undefined") {
    URL.revokeObjectURL(previewUrl);
  }
}

exports.compressImage = compressImage;
exports.validateImage = validateImage;
exports.createPreview = createPreview;
exports.revokePreview = revokePreview;
},
"./edit-flow.js": function(module, exports, __require) {
const { mergeCalculationResult, toCalculationItems, updateItem } = __require("./state.js");

const CATALOG_SELECTION_REQUIRED_MESSAGE = exports.CATALOG_SELECTION_REQUIRED_MESSAGE =
  "Selecciona un alimento del catálogo para calcular sus nutrientes.";

const PENDING_FOOD_SEARCH_MESSAGE = exports.PENDING_FOOD_SEARCH_MESSAGE =
  "Busca y selecciona el alimento correcto en el catálogo Royal.";

function positiveNumber(value) {
  const number = Number(value);
  return Number.isFinite(number) && number > 0 ? number : null;
}

function cleanFoodKey(value) {
  return typeof value === "string" && value.trim() ? value.trim() : null;
}

function copyPortionGrams(value) {
  return value && typeof value === "object" && !Array.isArray(value)
    ? { ...value }
    : {};
}

function supportedUnitsFor(values = {}) {
  const units = Array.isArray(values.supported_units) ? values.supported_units : [];
  const portionUnits = Object.keys(copyPortionGrams(values.portion_grams));
  const merged = ["g", ...units, ...portionUnits].filter(Boolean);

  return [...new Set(merged)];
}

function formatDerivedPortionNumber(value) {
  if (!Number.isFinite(value)) {
    return "";
  }

  const rounded =
    Math.abs(value - Math.round(value)) < 0.005
      ? Math.round(value)
      : Math.round((value + Number.EPSILON) * 100) / 100;

  return String(rounded);
}

function getGramsPerSelectedUnit(values = {}) {
  if (values.unit === "g") {
    return 1;
  }

  const grams = copyPortionGrams(values.portion_grams)[values.unit];
  const number = Number(grams);

  return Number.isFinite(number) && number > 0 ? number : null;
}

function syncEditPortionValues(values = {}, lastEditedField = null) {
  const next = { ...values };
  const gramsPerUnit = getGramsPerSelectedUnit(next);

  if (!gramsPerUnit) {
    return next;
  }

  if (lastEditedField === "quantity" || lastEditedField === "unit") {
    const quantity = positiveNumber(next.quantity);
    if (quantity) {
      next.weight_g = formatDerivedPortionNumber(quantity * gramsPerUnit);
    }
  }

  if (lastEditedField === "weight_g") {
    const weight = positiveNumber(next.weight_g);
    if (weight) {
      next.quantity = formatDerivedPortionNumber(weight / gramsPerUnit);
    }
  }

  return next;
}

function hasKnownPortionConversion(values = {}) {
  return Boolean(getGramsPerSelectedUnit(values));
}

function applyCatalogSelectionToEditValues(values = {}, food = {}) {
  const supportedUnits = food.supported_units?.length
    ? food.supported_units
    : ["g", ...Object.keys(food.portion_grams || {})];
  const portionGrams = copyPortionGrams(food.portion_grams);
  const currentWeight = positiveNumber(values.weight_g);
  const currentUnit = typeof values.unit === "string" ? values.unit : "";
  const nextUnit = supportedUnits.includes(currentUnit)
    ? currentUnit
    : food.default_unit || supportedUnits[0] || "g";
  const next = {
    ...values,
    food_key: cleanFoodKey(food.food_key),
    name: food.display_name || values.name || "",
    category: food.category || null,
    nutrition_source: food.nutrition_source || "Base Royal local",
    nutrition_match: "exact",
    supported_units: [...new Set(supportedUnits.length ? supportedUnits : ["g"])],
    portion_grams: portionGrams,
    unit: nextUnit,
    needs_confirmation: false,
  };

  if (currentWeight) {
    next.weight_g = formatDerivedPortionNumber(currentWeight);
    return syncEditPortionValues(next, "weight_g");
  }

  return syncEditPortionValues(next, "quantity");
}

function createEditCatalogSelection(food = {}) {
  const foodKey = cleanFoodKey(food.food_key ?? food.foodKey);

  if (!foodKey) {
    return null;
  }

  const displayName = food.display_name ?? food.displayName ?? "";
  const availableUnits = food.supported_units ?? food.availableUnits ?? ["g"];

  return {
    foodKey,
    displayName,
    category: food.category || null,
    state: food.state || null,
    source: food.nutrition_source ?? food.source ?? "",
    availableUnits,
    nutrientsPer100g: food.nutrients_per_100g ?? food.nutrientsPer100g ?? null,
    food_key: foodKey,
    display_name: displayName,
    default_unit: food.default_unit ?? food.defaultUnit ?? availableUnits[0] ?? "g",
    supported_units: availableUnits,
    portion_grams: copyPortionGrams(food.portion_grams ?? food.portionGrams),
    nutrition_source: food.nutrition_source ?? food.source ?? "Base Royal local",
  };
}

function validateEditCatalogSelection(values = {}, selectedCatalogFood = null) {
  if (values.source === "manual_nutrition") {
    return { valid: true, message: "" };
  }

  if (cleanFoodKey(values.food_key) || cleanFoodKey(selectedCatalogFood?.foodKey)) {
    return { valid: true, message: "" };
  }

  return {
    valid: false,
    message: CATALOG_SELECTION_REQUIRED_MESSAGE,
  };
}

function createEditValues(item = {}) {
  return {
    food_key: item.food_key ?? null,
    name: item.name ?? "",
    quantity: item.quantity ?? 1,
    unit: item.unit ?? "g",
    weight_g: item.weight_g ?? "",
    preparation: item.preparation ?? "",
    portion_confidence: item.portion_confidence ?? "medium",
    source: item.source || "detected",
    nutrition_source: item.nutrition_source || "",
    nutrition_match: item.nutrition_match || null,
    category: item.category || null,
    supported_units: item.supported_units || [],
    portion_grams: item.portion_grams || {},
    needs_confirmation: item.needs_confirmation === true,
  };
}

function buildEditChanges(values = {}) {
  return {
    name: values.name,
    quantity: Number(values.quantity),
    unit: values.unit,
    weight_g:
      values.weight_g === "" ||
      values.weight_g === undefined ||
      values.weight_g === null
        ? null
        : Number(values.weight_g),
    preparation: values.preparation,
    portion_confidence: values.portion_confidence,
    food_key: cleanFoodKey(values.food_key),
    nutrition_source: values.nutrition_source,
    nutrition_match: values.nutrition_match,
    category: values.category || null,
    supported_units: supportedUnitsFor(values),
    portion_grams: copyPortionGrams(values.portion_grams),
    needs_confirmation:
      values.source === "manual_nutrition"
        ? false
        : !cleanFoodKey(values.food_key),
  };
}

function beginEditSave(modalState) {
  return {
    ...modalState,
    isSaving: true,
    error: null,
  };
}

function failEditSave(modalState, error) {
  return {
    ...modalState,
    isSaving: false,
    error:
      error?.message ||
      "No pudimos recalcular este alimento. Revisa los datos e intenta de nuevo.",
  };
}

function completeEditSave() {
  return null;
}

function canSubmitEdit(modalState) {
  return Boolean(modalState?.itemId) && modalState.isSaving !== true;
}


function isDirectBackdropClick(event) {
  return Boolean(event) && event.target === event.currentTarget;
}

function handleEditModalBackdropClick(event, closeEditModal) {
  if (!isDirectBackdropClick(event)) {
    return false;
  }

  return closeEditModal?.() === true;
}

function handleEditModalContentClick(event, closeEditModal) {
  const closeButton = event?.target?.closest?.('[data-action="close-modal"]');

  if (closeButton) {
    event?.preventDefault?.();
    closeEditModal?.();
  }

  event?.stopPropagation?.();
  return Boolean(closeButton);
}

function handleEditModalEscape(event, closeEditModal) {
  if (event?.key !== "Escape") {
    return false;
  }

  return closeEditModal?.() === true;
}

function attachEditModalClickGuards({ backdrop, modalContent, closeEditModal } = {}) {
  if (!backdrop || !modalContent) {
    return false;
  }

  if (backdrop.dataset?.modalListenersAttached === "true") {
    return false;
  }

  if (backdrop.dataset) {
    backdrop.dataset.modalListenersAttached = "true";
  }

  backdrop.addEventListener("click", (event) => {
    handleEditModalBackdropClick(event, closeEditModal);
  });
  modalContent.addEventListener("click", (event) => {
    handleEditModalContentClick(event, closeEditModal);
  });

  return true;
}

async function saveEditedItem({
  items,
  itemId,
  values,
  selectedCatalogFood = null,
  calculateMealImpl,
}) {
  const currentItem = items.find((item) => item.id === itemId);
  const selectedFoodKey = cleanFoodKey(selectedCatalogFood?.foodKey);
  const effectiveValues = {
    ...createEditValues(currentItem),
    ...values,
    food_key:
      cleanFoodKey(values?.food_key) ||
      selectedFoodKey ||
      cleanFoodKey(currentItem?.food_key),
  };
  const validation = validateEditCatalogSelection(effectiveValues, selectedCatalogFood);

  if (!validation.valid) {
    throw new Error(validation.message);
  }

  const nextItems = updateItem(items, itemId, buildEditChanges(effectiveValues));
  const calculationItems = toCalculationItems(nextItems);
  const result = await calculateMealImpl(calculationItems);

  return mergeCalculationResult(nextItems, result);
}

exports.saveEditedItem = saveEditedItem;
exports.formatDerivedPortionNumber = formatDerivedPortionNumber;
exports.getGramsPerSelectedUnit = getGramsPerSelectedUnit;
exports.syncEditPortionValues = syncEditPortionValues;
exports.hasKnownPortionConversion = hasKnownPortionConversion;
exports.applyCatalogSelectionToEditValues = applyCatalogSelectionToEditValues;
exports.createEditCatalogSelection = createEditCatalogSelection;
exports.validateEditCatalogSelection = validateEditCatalogSelection;
exports.createEditValues = createEditValues;
exports.buildEditChanges = buildEditChanges;
exports.beginEditSave = beginEditSave;
exports.failEditSave = failEditSave;
exports.completeEditSave = completeEditSave;
exports.canSubmitEdit = canSubmitEdit;
exports.isDirectBackdropClick = isDirectBackdropClick;
exports.handleEditModalBackdropClick = handleEditModalBackdropClick;
exports.handleEditModalContentClick = handleEditModalContentClick;
exports.handleEditModalEscape = handleEditModalEscape;
exports.attachEditModalClickGuards = attachEditModalClickGuards;
},
"./state.js": function(module, exports, __require) {
const EMPTY_TOTALS = exports.EMPTY_TOTALS = {
  calories: 0,
  protein_g: 0,
  carbs_g: 0,
  fat_g: 0,
  items_calculated: 0,
  items_pending: 0,
  totals_complete: true,
};

const EMPTY_RANGE = exports.EMPTY_RANGE = {
  calories_min: 0,
  calories_max: 0,
  range_complete: true,
};

const HIDDEN_INGREDIENTS = exports.HIDDEN_INGREDIENTS = [
  {
    label: "Aceite",
    food_key: "cooking_oil",
    defaultQuantity: 1,
    defaultUnit: "cucharada",
    units: ["cucharadita", "cucharada", "g"],
  },
  {
    label: "Aceite de oliva",
    food_key: "olive_oil",
    defaultQuantity: 1,
    defaultUnit: "cucharada",
    units: ["cucharadita", "cucharada", "g"],
  },
  {
    label: "Mantequilla",
    food_key: "butter",
    defaultQuantity: 1,
    defaultUnit: "cucharadita",
    units: ["cucharadita", "cucharada", "g"],
  },
  {
    label: "Mayonesa",
    food_key: "mayonnaise",
    defaultQuantity: 1,
    defaultUnit: "cucharada",
    units: ["cucharadita", "cucharada", "g"],
  },
  {
    label: "Azúcar",
    food_key: "sugar",
    defaultQuantity: 1,
    defaultUnit: "cucharadita",
    units: ["cucharadita", "cucharada", "g"],
  },
  {
    label: "Vinagreta",
    food_key: "vinaigrette_dressing",
    defaultQuantity: 1,
    defaultUnit: "cucharada",
    units: ["cucharada", "g"],
  },
  {
    label: "Aderezo cremoso",
    food_key: "creamy_dressing",
    defaultQuantity: 1,
    defaultUnit: "cucharada",
    units: ["cucharada", "g"],
  },
  {
    label: "Crema",
    food_key: "cream",
    defaultQuantity: 1,
    defaultUnit: "cucharada",
    units: ["cucharada", "g"],
  },
  {
    label: "Queso",
    food_key: "cheese_generic",
    defaultQuantity: 1,
    defaultUnit: "porción",
    units: ["porción", "g"],
  },
];

const MANUAL_LIMITS = {
  calories: 5000,
  protein_g: 500,
  carbs_g: 1000,
  fat_g: 500,
};

function createInitialState(overrides = {}) {
  return {
    imagePreview: null,
    compressedFile: null,
    mealType: "",
    notes: "",
    detectedItems: [],
    calculatedItems: [],
    totals: { ...EMPTY_TOTALS },
    estimatedRange: { ...EMPTY_RANGE },
    warnings: [],
    currentScreen: "start",
    loading: false,
    error: null,
    mealSummary: "",
    analysisConfidence: null,
    possibleHiddenIngredients: [],
    clarifyingQuestions: [],
    resultStatus: "draft",
    manualMode: false,
    ...overrides,
  };
}

function numberOrNull(value) {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  const number = Number(value);
  return Number.isFinite(number) ? number : null;
}

function coalesce(...values) {
  return values.find((value) => value !== undefined && value !== null);
}

function normalizeMealItem(item = {}) {
  const weight = coalesce(item.weight_g, item.estimated_weight_g);
  const quantity = coalesce(item.quantity, item.estimated_quantity, weight, 1);
  const source = item.source || "detected";

  return {
    id: String(item.id || cryptoRandomId("item")),
    food_key: item.food_key ?? null,
    name: String(item.name || item.display_name || "Alimento por revisar"),
    preparation: String(item.preparation || ""),
    quantity: numberOrNull(quantity) ?? 1,
    unit: item.unit || "g",
    weight_g: numberOrNull(weight),
    calories: numberOrNull(item.calories),
    protein_g: numberOrNull(item.protein_g),
    carbs_g: numberOrNull(item.carbs_g),
    fat_g: numberOrNull(item.fat_g),
    identity_confidence: item.identity_confidence || null,
    portion_confidence: item.portion_confidence || "medium",
    source,
    nutrition_source: item.nutrition_source || (!item.food_key || item.calories === null ? "Sin información nutricional válida" : "Base Royal local"),
    nutrition_match: item.nutrition_match || null,
    category: item.category || null,
    supported_units: Array.isArray(item.supported_units) ? item.supported_units : [],
    portion_grams: item.portion_grams && typeof item.portion_grams === "object" ? item.portion_grams : {},
    needs_confirmation: item.needs_confirmation === true || !item.food_key || item.calories === null,
    visible: item.visible !== false,
    quantity_label: item.quantity_label || "",
    manual_nutrition: item.manual_nutrition || null,
  };
}

function normalizeAnalyzeResponse(payload = {}) {
  const detectedItems = Array.isArray(payload.detected_items)
    ? payload.detected_items.map(normalizeMealItem)
    : [];
  const pending = getPendingCount(detectedItems);
  const totals = {
    ...EMPTY_TOTALS,
    ...(payload.totals || {}),
    items_pending: pending || payload.totals?.items_pending || 0,
    totals_complete: pending === 0 && payload.totals?.totals_complete !== false,
  };
  const estimatedRange = {
    ...EMPTY_RANGE,
    ...(payload.estimated_range || {}),
    range_complete: pending === 0 && (payload.estimated_range?.range_complete ?? payload.range_complete ?? true) !== false,
  };

  return {
    detectedItems,
    calculatedItems: detectedItems,
    totals,
    estimatedRange,
    warnings: Array.isArray(payload.warnings) ? payload.warnings : [],
    mealSummary: payload.meal_summary || "",
    analysisConfidence: payload.analysis_confidence || null,
    possibleHiddenIngredients: Array.isArray(payload.possible_hidden_ingredients) ? payload.possible_hidden_ingredients : [],
    clarifyingQuestions: Array.isArray(payload.clarifying_questions) ? payload.clarifying_questions : [],
    currentScreen: detectedItems.length > 0 ? "review" : "manual",
    resultStatus: "draft",
    manualMode: false,
  };
}

function getPendingCount(items = []) {
  return items.filter((item) => !isCalculableItem(item)).length;
}

function isCalculableItem(item) {
  if (!item) return false;
  if (item.source === "manual_nutrition") return Boolean(item.manual_nutrition);
  return typeof item.food_key === "string" && item.food_key.trim() !== "";
}

function toCalculationItems(items = []) {
  return items.filter(isCalculableItem).map((item) => {
    if (item.source === "manual_nutrition") {
      return {
        id: item.id,
        name: item.name,
        quantity_label: item.quantity_label || "",
        source: "manual_nutrition",
        manual_nutrition: item.manual_nutrition,
        portion_confidence: item.portion_confidence || "high",
      };
    }

    const payload = {
      id: item.id,
      food_key: item.food_key,
      name: item.name,
      quantity: Number(item.quantity),
      unit: item.unit,
      source: item.source || "manual_catalog",
      portion_confidence: item.portion_confidence || "medium",
    };

    if (item.weight_g !== null && item.weight_g !== undefined && item.weight_g !== "") {
      payload.weight_g = Number(item.weight_g);
    }

    return payload;
  });
}

function mergeCalculationResult(currentItems = [], result = {}) {
  const calculatedById = new Map((result.items || []).map((item) => [item.id, item]));
  const mergedItems = currentItems.map((item) => {
    const calculated = calculatedById.get(item.id);

    if (!calculated) {
      return item;
    }

    return {
      ...item,
      ...calculated,
      preparation: item.preparation || "",
      identity_confidence: item.identity_confidence || null,
      needs_confirmation: item.needs_confirmation && !calculated.food_key,
      manual_nutrition: item.manual_nutrition || null,
      quantity_label: item.quantity_label || calculated.quantity_label || "",
    };
  });
  const pending = getPendingCount(mergedItems);
  const totals = {
    ...EMPTY_TOTALS,
    ...(result.totals || {}),
    items_pending: pending + Number(result.totals?.items_pending || 0),
    totals_complete: pending === 0 && result.totals?.totals_complete !== false,
  };
  const estimatedRange = {
    ...EMPTY_RANGE,
    ...(result.estimated_range || {}),
    range_complete: pending === 0 && result.estimated_range?.range_complete !== false,
  };

  return {
    items: mergedItems,
    totals,
    estimatedRange,
    warnings: Array.isArray(result.warnings) ? result.warnings : [],
  };
}

function updateItem(items, itemId, changes) {
  return items.map((item) =>
    item.id === itemId
      ? normalizeMealItem({ ...item, ...changes, needs_confirmation: changes.needs_confirmation ?? item.needs_confirmation })
      : item,
  );
}

function updateItemWeight(items, itemId, weight_g) {
  return updateItem(items, itemId, { weight_g: Number(weight_g) });
}

function removeItem(items, itemId) {
  return items.filter((item) => item.id !== itemId);
}

function addCatalogItem(items, food, fields = {}) {
  const supportedUnits = food.supported_units || [food.default_unit || "g"];
  const item = normalizeMealItem({
    id: fields.id || cryptoRandomId("catalog"),
    food_key: food.food_key,
    name: fields.name || food.display_name,
    quantity: Number(fields.quantity || 100),
    unit: fields.unit || food.default_unit || supportedUnits[0] || "g",
    weight_g: fields.weight_g === "" || fields.weight_g === undefined ? null : Number(fields.weight_g),
    preparation: fields.preparation || "",
    source: "manual_catalog",
    portion_confidence: fields.portion_confidence || "medium",
    nutrition_source: food.nutrition_source,
    category: food.category || null,
    supported_units: food.supported_units || [],
    portion_grams: food.portion_grams || {},
    needs_confirmation: false,
  });

  return [...items, item];
}

function getHiddenIngredient(foodKey) {
  return HIDDEN_INGREDIENTS.find((ingredient) => ingredient.food_key === foodKey) || null;
}

function addHiddenIngredient(items, foodKey, fields = {}) {
  const ingredient = getHiddenIngredient(foodKey);

  if (!ingredient) {
    throw new Error("Ingrediente oculto no reconocido.");
  }

  const item = normalizeMealItem({
    id: fields.id || cryptoRandomId("hidden"),
    food_key: ingredient.food_key,
    name: ingredient.label,
    quantity: Number(fields.quantity || ingredient.defaultQuantity),
    unit: fields.unit || ingredient.defaultUnit,
    weight_g: fields.weight_g === "" || fields.weight_g === undefined ? null : Number(fields.weight_g),
    preparation: fields.preparation || "No visible en la fotografía",
    source: "hidden_ingredient",
    portion_confidence: fields.portion_confidence || "high",
    needs_confirmation: false,
  });

  return [...items, item];
}

function validateManualNutrition(values = {}) {
  for (const [key, max] of Object.entries(MANUAL_LIMITS)) {
    const value = Number(values[key]);

    if (!Number.isFinite(value) || value < 0 || value > max) {
      return {
        valid: false,
        code: "INVALID_MANUAL_NUTRITION",
        message: "Completa la nutrición manual con valores válidos.",
      };
    }
  }

  return { valid: true, code: null, message: "" };
}

function addManualItem(items, fields = {}) {
  const manual_nutrition = {
    calories: Number(fields.calories),
    protein_g: Number(fields.protein_g),
    carbs_g: Number(fields.carbs_g),
    fat_g: Number(fields.fat_g),
  };
  const validation = validateManualNutrition(manual_nutrition);

  if (!validation.valid) {
    const error = new Error(validation.message);
    error.code = validation.code;
    throw error;
  }

  if (!String(fields.name || "").trim()) {
    const error = new Error("Escribe el nombre del alimento personalizado.");
    error.code = "INVALID_ITEM_NAME";
    throw error;
  }

  const item = normalizeMealItem({
    id: fields.id || cryptoRandomId("manual"),
    name: String(fields.name).trim(),
    quantity_label: String(fields.quantity_label || "Porción completa").trim(),
    source: "manual_nutrition",
    manual_nutrition,
    calories: manual_nutrition.calories,
    protein_g: manual_nutrition.protein_g,
    carbs_g: manual_nutrition.carbs_g,
    fat_g: manual_nutrition.fat_g,
    portion_confidence: "high",
    nutrition_source: "Manual",
    nutrition_match: "manual",
    needs_confirmation: false,
  });

  return [...items, item];
}

function createManualModeState(overrides = {}) {
  return createInitialState({
    currentScreen: "manual",
    imagePreview: null,
    compressedFile: null,
    manualMode: true,
    ...overrides,
  });
}

function cryptoRandomId(prefix) {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return prefix + "_" + crypto.randomUUID();
  }

  return prefix + "_" + Math.random().toString(36).slice(2, 10);
}

exports.createInitialState = createInitialState;
exports.normalizeMealItem = normalizeMealItem;
exports.normalizeAnalyzeResponse = normalizeAnalyzeResponse;
exports.getPendingCount = getPendingCount;
exports.isCalculableItem = isCalculableItem;
exports.toCalculationItems = toCalculationItems;
exports.mergeCalculationResult = mergeCalculationResult;
exports.updateItem = updateItem;
exports.updateItemWeight = updateItemWeight;
exports.removeItem = removeItem;
exports.addCatalogItem = addCatalogItem;
exports.getHiddenIngredient = getHiddenIngredient;
exports.addHiddenIngredient = addHiddenIngredient;
exports.validateManualNutrition = validateManualNutrition;
exports.addManualItem = addManualItem;
exports.createManualModeState = createManualModeState;
},
"./catalog-search-flow.js": function(module, exports, __require) {
function isCatalogSearchInput(target) {
  return target?.id === "food-search";
}

function preserveScrollDuring(windowRef, callback) {
  const scrollX = Number(windowRef?.scrollX ?? 0);
  const scrollY = Number(windowRef?.scrollY ?? 0);
  const result = callback?.();

  if (
    windowRef &&
    typeof windowRef.scrollTo === "function" &&
    Number.isFinite(scrollY) &&
    windowRef.scrollY !== scrollY
  ) {
    windowRef.scrollTo(scrollX, scrollY);
  }

  return result;
}

function preventCatalogSearchEnter(event) {
  if (event?.key !== "Enter" || !isCatalogSearchInput(event.target)) {
    return false;
  }

  event.preventDefault?.();
  return true;
}

function updateCatalogSearchDom({ windowRef, resultsContainer, selectedContainer, resultsHtml = "", selectedHtml = "", activeElement } = {}) {
  return preserveScrollDuring(windowRef, () => {
    if (resultsContainer) {
      resultsContainer.innerHTML = resultsHtml;
    }

    if (selectedContainer) {
      selectedContainer.innerHTML = selectedHtml;
    }

    if (isCatalogSearchInput(activeElement) && typeof activeElement.focus === "function") {
      activeElement.focus({ preventScroll: true });
    }
  });
}

exports.isCatalogSearchInput = isCatalogSearchInput;
exports.preserveScrollDuring = preserveScrollDuring;
exports.preventCatalogSearchEnter = preventCatalogSearchEnter;
exports.updateCatalogSearchDom = updateCatalogSearchDom;
},
"./scan-limit.js": function(module, exports, __require) {
const USAGE_STORAGE_KEY = exports.USAGE_STORAGE_KEY = "royal_food_scan_usage_v1";
const DEFAULT_DAILY_SCAN_LIMIT = exports.DEFAULT_DAILY_SCAN_LIMIT = 5;
const PACIFIC_TIME_ZONE = exports.PACIFIC_TIME_ZONE = "America/Los_Angeles";
const WINDOW_MS = exports.WINDOW_MS = 24 * 60 * 60 * 1000;

function envScanLimit() {
  return undefined;
}

function parseDailyScanLimit(value, fallback = DEFAULT_DAILY_SCAN_LIMIT) {
  const number = Number(value);

  if (!Number.isInteger(number) || number < 1 || number > 100) {
    return fallback;
  }

  return number;
}

const SCAN_LIMIT = exports.SCAN_LIMIT = parseDailyScanLimit(envScanLimit());

function safeParse(value) {
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
}

function validNow(now) {
  return typeof now === "number" && Number.isFinite(now) && now > 0;
}

function pacificFormatter() {
  return new Intl.DateTimeFormat("en-US", {
    timeZone: PACIFIC_TIME_ZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hourCycle: "h23",
  });
}

function partsToObject(parts) {
  return Object.fromEntries(
    parts
      .filter((part) => part.type !== "literal")
      .map((part) => [part.type, Number(part.value)]),
  );
}

function getPacificParts(timestamp) {
  return partsToObject(pacificFormatter().formatToParts(new Date(timestamp)));
}

function localDatePlusOne({ year, month, day }) {
  const next = new Date(Date.UTC(year, month - 1, day + 1, 12, 0, 0));
  return {
    year: next.getUTCFullYear(),
    month: next.getUTCMonth() + 1,
    day: next.getUTCDate(),
  };
}

function zonedLocalTimeToUtc({ year, month, day, hour = 0, minute = 0, second = 0 }) {
  const desiredAsUtc = Date.UTC(year, month - 1, day, hour, minute, second);
  let candidate = desiredAsUtc;

  for (let index = 0; index < 4; index += 1) {
    const actual = getPacificParts(candidate);
    const actualAsUtc = Date.UTC(
      actual.year,
      actual.month - 1,
      actual.day,
      actual.hour,
      actual.minute,
      actual.second,
    );
    const difference = desiredAsUtc - actualAsUtc;

    if (difference === 0) {
      return candidate;
    }

    candidate += difference;
  }

  return candidate;
}

function fallbackQuotaPeriod(now) {
  const safeNow = validNow(now) ? now : Date.now();
  const periodIndex = Math.floor(safeNow / WINDOW_MS);
  const periodStartedAt = periodIndex * WINDOW_MS;
  const nextResetAt = periodStartedAt + WINDOW_MS;

  return {
    periodId: "fallback-" + periodIndex,
    periodStartedAt,
    nextResetAt,
    isFallback: true,
  };
}

function getPacificQuotaPeriod(now = Date.now()) {
  if (!validNow(now)) {
    return fallbackQuotaPeriod(now);
  }

  try {
    const parts = getPacificParts(now);

    if (!parts.year || !parts.month || !parts.day) {
      return fallbackQuotaPeriod(now);
    }

    const periodStartedAt = zonedLocalTimeToUtc({
      year: parts.year,
      month: parts.month,
      day: parts.day,
    });
    const nextLocalDate = localDatePlusOne(parts);
    const nextResetAt = zonedLocalTimeToUtc(nextLocalDate);
    const periodId = [
      parts.year,
      String(parts.month).padStart(2, "0"),
      String(parts.day).padStart(2, "0"),
    ].join("-");

    if (
      !Number.isFinite(periodStartedAt) ||
      !Number.isFinite(nextResetAt) ||
      nextResetAt <= now
    ) {
      return fallbackQuotaPeriod(now);
    }

    return {
      periodId,
      periodStartedAt,
      nextResetAt,
      isFallback: false,
    };
  } catch {
    return fallbackQuotaPeriod(now);
  }
}

function defaultUsage(now) {
  const period = getPacificQuotaPeriod(now);

  return {
    quotaPeriodId: period.periodId,
    quotaPeriodStartedAt: period.periodStartedAt,
    nextResetAt: period.nextResetAt,
    successfulScans: 0,
  };
}

function normalizeUsage(raw, now, limit) {
  const currentPeriod = getPacificQuotaPeriod(now);

  if (
    !raw ||
    typeof raw !== "object" ||
    Array.isArray(raw) ||
    typeof raw.successfulScans !== "number" ||
    !Number.isFinite(raw.successfulScans) ||
    raw.successfulScans < 0 ||
    raw.quotaPeriodId !== currentPeriod.periodId ||
    typeof raw.nextResetAt !== "number" ||
    !Number.isFinite(raw.nextResetAt) ||
    raw.nextResetAt <= now
  ) {
    return defaultUsage(now);
  }

  return {
    quotaPeriodId: currentPeriod.periodId,
    quotaPeriodStartedAt: currentPeriod.periodStartedAt,
    nextResetAt: currentPeriod.nextResetAt,
    successfulScans: Math.min(limit, Math.floor(raw.successfulScans)),
  };
}

function readUsage(storage = localStorage, now = Date.now(), limit = SCAN_LIMIT) {
  const usage = normalizeUsage(
    safeParse(storage.getItem(USAGE_STORAGE_KEY)),
    now,
    limit,
  );
  storage.setItem(USAGE_STORAGE_KEY, JSON.stringify(usage));
  return usage;
}

function getUsageStatus(storage = localStorage, now = Date.now(), limit = SCAN_LIMIT) {
  const usage = readUsage(storage, now, limit);
  const remaining = Math.max(0, limit - usage.successfulScans);
  const resetsAt = usage.nextResetAt;
  const millisecondsUntilReset = Math.max(0, resetsAt - now);

  return {
    ...usage,
    limit,
    remaining,
    isLimitReached: remaining <= 0,
    resetsAt,
    millisecondsUntilReset,
    minutesUntilReset: Math.max(0, Math.ceil(millisecondsUntilReset / (60 * 1000))),
    hoursUntilReset: Math.max(0, Math.ceil(millisecondsUntilReset / (60 * 60 * 1000))),
  };
}

function canUseAutoScan(storage = localStorage, now = Date.now(), limit = SCAN_LIMIT) {
  return !getUsageStatus(storage, now, limit).isLimitReached;
}

function incrementSuccessfulScan(storage = localStorage, now = Date.now(), limit = SCAN_LIMIT) {
  const usage = readUsage(storage, now, limit);
  const updated = {
    quotaPeriodId: usage.quotaPeriodId,
    quotaPeriodStartedAt: usage.quotaPeriodStartedAt,
    nextResetAt: usage.nextResetAt,
    successfulScans: Math.min(limit, usage.successfulScans + 1),
  };
  storage.setItem(USAGE_STORAGE_KEY, JSON.stringify(updated));
  return getUsageStatus(storage, now, limit);
}

function markUsageLimitReached(
  storage = localStorage,
  now = Date.now(),
  limit = SCAN_LIMIT,
  nextResetAt = null,
) {
  const usage = readUsage(storage, now, limit);
  const serverResetAt = Date.parse(nextResetAt);
  const resetAt = Number.isFinite(serverResetAt) && serverResetAt > now
    ? serverResetAt
    : usage.nextResetAt;
  const updated = {
    quotaPeriodId: usage.quotaPeriodId,
    quotaPeriodStartedAt: usage.quotaPeriodStartedAt,
    nextResetAt: resetAt,
    successfulScans: limit,
  };

  storage.setItem(USAGE_STORAGE_KEY, JSON.stringify(updated));
  return getUsageStatus(storage, now, limit);
}

function resetUsage(storage = localStorage, now = Date.now(), limit = SCAN_LIMIT) {
  const usage = defaultUsage(now);
  storage.setItem(USAGE_STORAGE_KEY, JSON.stringify(usage));
  return getUsageStatus(storage, now, limit);
}

exports.parseDailyScanLimit = parseDailyScanLimit;
exports.getPacificQuotaPeriod = getPacificQuotaPeriod;
exports.readUsage = readUsage;
exports.getUsageStatus = getUsageStatus;
exports.canUseAutoScan = canUseAutoScan;
exports.incrementSuccessfulScan = incrementSuccessfulScan;
exports.markUsageLimitReached = markUsageLimitReached;
exports.resetUsage = resetUsage;
},
"./scan-limit-ui.js": function(module, exports, __require) {
function availableAnalysesLabel(count) {
  return count === 1
    ? "1 análisis disponible"
    : String(count) + " análisis disponibles";
}

function formatResetCountdown(usage) {
  const minutes = Number(usage?.minutesUntilReset || 0);

  if (!Number.isFinite(minutes) || minutes <= 0) {
    return "poco tiempo";
  }

  if (minutes < 60) {
    return minutes === 1 ? "1 minuto" : minutes + " minutos";
  }

  const hours = Math.ceil(minutes / 60);
  return hours === 1 ? "1 hora" : hours + " horas";
}

function renderUsageText(usage) {
  if (usage?.isLimitReached) {
    return "";
  }

  return availableAnalysesLabel(usage?.remaining || 0) + " hoy.";
}

function createLimitReachedCopy(usage) {
  return {
    title: "0 análisis disponibles hoy",
    resetText: "Se renuevan en " + formatResetCountdown(usage) + ".",
    secondaryText: "Puedes seguir agregando y calculando alimentos en modo manual.",
    buttonText: "Continuar en modo manual",
  };
}

function renderLimitReachedCard(usage, escapeHtml = String) {
  const copy = createLimitReachedCopy(usage);

  return `
    <div class="error-box limit-reached-card" role="status">
      <h3>${escapeHtml(copy.title)}</h3>
      <p>${escapeHtml(copy.resetText)}</p>
      <p class="muted">${escapeHtml(copy.secondaryText)}</p>
      <button class="btn btn--dark" type="button" data-action="manual-mode">${escapeHtml(copy.buttonText)}</button>
    </div>`;
}

exports.availableAnalysesLabel = availableAnalysesLabel;
exports.formatResetCountdown = formatResetCountdown;
exports.renderUsageText = renderUsageText;
exports.createLimitReachedCopy = createLimitReachedCopy;
exports.renderLimitReachedCard = renderLimitReachedCard;
},
"./royal-reading-engine.js": function(module, exports, __require) {
const { normalizeRoyalGoals } = __require("./royal-goals.js");
const { ROYAL_READING_COPY: COPY } = __require("./royal-reading-copy.js");
const { ROYAL_PRODUCTS } = __require("./royal-products.js");

const MEAL_SHARE_RANGES = exports.MEAL_SHARE_RANGES = Object.freeze({
  calories: Object.freeze({
    desayuno: Object.freeze({ min: 0.20, max: 0.30 }),
    comida: Object.freeze({ min: 0.30, max: 0.40 }),
    cena: Object.freeze({ min: 0.25, max: 0.35 }),
    snack: Object.freeze({ min: 0.05, max: 0.15 }),
  }),
  protein: Object.freeze({
    desayuno: Object.freeze({ min: 0.20, max: 0.30 }),
    comida: Object.freeze({ min: 0.25, max: 0.35 }),
    cena: Object.freeze({ min: 0.25, max: 0.35 }),
    snack: Object.freeze({ min: 0.08, max: 0.15 }),
  }),
});

const CONTEXTUAL_PROTEIN_BANDS = Object.freeze({
  desayuno: Object.freeze({ veryLowBelow: 10, lowBelow: 20, adequateBelow: 30, solidBelow: 40 }),
  comida: Object.freeze({ veryLowBelow: 15, lowBelow: 25, adequateBelow: 35, solidBelow: 50 }),
  cena: Object.freeze({ veryLowBelow: 15, lowBelow: 25, adequateBelow: 35, solidBelow: 45 }),
  snack: Object.freeze({ veryLowBelow: 5, lowBelow: 10, adequateBelow: 15, solidBelow: 20 }),
  otro: Object.freeze({ veryLowBelow: 10, lowBelow: 20, adequateBelow: 30, solidBelow: 40 }),
});

const CONTEXTUAL_PRODUCT_RULES = Object.freeze({
  desayuno: Object.freeze({ proteinBelow: 15, caloriesAt: 250, carbsAt: 30 }),
  comida: Object.freeze({ proteinBelow: 20, caloriesAt: 350, carbsAt: null }),
  cena: Object.freeze({ proteinBelow: 20, caloriesAt: 300, carbsAt: null }),
  snack: Object.freeze({ proteinBelow: 10, caloriesAt: 250, carbsAt: 35 }),
  otro: Object.freeze({ proteinBelow: 10, caloriesAt: 300, carbsAt: null }),
});

const MEAL_ALIASES = Object.freeze({
  breakfast: "desayuno",
  desayuno: "desayuno",
  lunch: "comida",
  comida: "comida",
  dinner: "cena",
  cena: "cena",
  snack: "snack",
  other: "otro",
  otro: "otro",
});

const HIDDEN_INGREDIENT_MATCHERS = Object.freeze([
  { label: "aceite", pattern: /\b(aceite|oil|olive oil|vegetable oil)\b/i },
  { label: "aderezo", pattern: /\b(aderezo|dressing)\b/i },
  { label: "vinagreta", pattern: /\b(vinagreta|vinaigrette)\b/i },
  { label: "mantequilla", pattern: /\b(mantequilla|butter)\b/i },
  { label: "mayonesa", pattern: /\b(mayonesa|mayonnaise)\b/i },
  { label: "crema", pattern: /\b(crema|cream)\b/i },
  { label: "queso", pattern: /\b(queso|cheese)\b/i },
  { label: "azúcar", pattern: /\b(azúcar|azucar|sugar)\b/i },
  { label: "miel", pattern: /\b(miel|honey)\b/i },
  { label: "jarabe", pattern: /\b(jarabe|syrup)\b/i },
  { label: "yogur", pattern: /\b(yogur|yogurt)\b/i },
  { label: "granola", pattern: /\bgranola\b/i },
  { label: "marinado", pattern: /\b(marinado|marinada|marinade)\b/i },
]);
const CALORIE_TOLERANCE = 0.03;
const PROTEIN_NEAR_FACTOR = 0.85;
const PERSONALIZED_PRODUCT_GAP_THRESHOLD_G = 10;

function numeric(value) {
  const number = Number(value);
  return Number.isFinite(number) ? number : 0;
}

function round(value, digits = 0) {
  const factor = 10 ** digits;
  return Math.round(numeric(value) * factor) / factor;
}

function classifyContextualProtein(mealProtein, bands) {
  if (mealProtein < bands.veryLowBelow) return "very_low";
  if (mealProtein < bands.lowBelow) return "low";
  if (mealProtein < bands.adequateBelow) return "adequate";
  if (mealProtein < bands.solidBelow) return "solid";
  return "high";
}

function contextualProteinMessage(mealType, status) {
  return (
    COPY.contextualProtein?.[mealType]?.[status] ??
    COPY.contextualProtein.otro[status] ??
    COPY.protein[status] ??
    null
  );
}

function personalizedProteinMessage(status) {
  if (status === "very_low") return COPY.protein.very_low;
  if (status === "solid") return COPY.protein.solid;
  return COPY.protein[status] ?? null;
}

function normalizeMealType(mealType) {
  return MEAL_ALIASES[String(mealType || "").trim().toLowerCase()] || "otro";
}

function unavailableAssessment(kind, mode) {
  return {
    kind,
    mode,
    status: "unavailable",
    message: null,
    share: null,
    minShare: null,
    maxShare: null,
    targetMin: null,
    targetMax: null,
  };
}

function assessCalories({ mealType, calories, goals, mode }) {
  const normalizedMealType = normalizeMealType(mealType);
  const mealCalories = numeric(calories);

  if (mode !== "personalized" || !goals) {
    if (normalizedMealType === "snack" && mealCalories >= 400) {
      return {
        ...unavailableAssessment("calories", "contextual"),
        status: "high",
        message: COPY.calories.contextualSnackLarge,
      };
    }

    return unavailableAssessment("calories", "contextual");
  }

  const range = MEAL_SHARE_RANGES.calories[normalizedMealType];
  if (!range) {
    return unavailableAssessment("calories", "personalized");
  }

  const share = goals.dailyCalories > 0 ? mealCalories / goals.dailyCalories : 0;
  let status = "in_range";

  if (share < range.min - CALORIE_TOLERANCE) {
    status = "low";
  } else if (share < range.min || share <= range.max + CALORIE_TOLERANCE && share > range.max) {
    status = "near_range";
  } else if (share > range.max + 0.10) {
    status = "very_high";
  } else if (share > range.max) {
    status = "high";
  }

  return {
    kind: "calories",
    mode: "personalized",
    status,
    message: COPY.calories[status],
    share: round(share, 3),
    minShare: range.min,
    maxShare: range.max,
    targetMin: round(goals.dailyCalories * range.min, 0),
    targetMax: round(goals.dailyCalories * range.max, 0),
  };
}

function assessProtein({ mealType, protein, goals, mode }) {
  const normalizedMealType = normalizeMealType(mealType);
  const mealProtein = numeric(protein);

  if (mode === "personalized" && goals) {
    const range = MEAL_SHARE_RANGES.protein[normalizedMealType];
    if (!range) {
      return unavailableAssessment("protein", "personalized");
    }

    const share = goals.dailyProtein > 0 ? mealProtein / goals.dailyProtein : 0;
    let status = "adequate";

    if (share < range.min * 0.5) {
      status = "very_low";
    } else if (share < range.min * PROTEIN_NEAR_FACTOR) {
      status = "low";
    } else if (share < range.min) {
      status = "adequate";
    } else if (share > range.max + 0.05) {
      status = "high";
    } else if (share > range.max) {
      status = "solid";
    }

    return {
      kind: "protein",
      mode: "personalized",
      status,
      message: personalizedProteinMessage(status),
      share: round(share, 3),
      minShare: range.min,
      maxShare: range.max,
      targetMin: round(goals.dailyProtein * range.min, 1),
      targetMax: round(goals.dailyProtein * range.max, 1),
    };
  }

  const bands = CONTEXTUAL_PROTEIN_BANDS[normalizedMealType] || CONTEXTUAL_PROTEIN_BANDS.otro;
  const status = classifyContextualProtein(mealProtein, bands);

  return {
    ...unavailableAssessment("protein", "contextual"),
    status,
    message: contextualProteinMessage(normalizedMealType, status),
    targetMin: bands.lowBelow,
    targetMax: bands.adequateBelow,
  };
}

function hasConfirmedHiddenIngredient(detectedItems = []) {
  return detectedItems.some((item) => {
    if (!item || item.source !== "hidden_ingredient") return false;
    return getRelevantHiddenIngredientLabels([
      String(item.name || "") + " " + String(item.food_key || ""),
    ]).length > 0;
  });
}

function getRelevantHiddenIngredientLabels(possibleHiddenIngredients = []) {
  const labels = [];

  for (const item of possibleHiddenIngredients) {
    const text = String(item || "");

    for (const matcher of HIDDEN_INGREDIENT_MATCHERS) {
      if (
        matcher.pattern.test(text) &&
        !labels.includes(matcher.label)
      ) {
        labels.push(matcher.label);
      }
    }
  }

  return labels;
}

function joinIngredientLabels(labels) {
  if (labels.length <= 1) {
    return labels[0] || "";
  }

  return labels.slice(0, -1).join(", ") + " o " + labels.at(-1);
}

function createHiddenIngredientMessage(possibleHiddenIngredients = [], detectedItems = []) {
  if (hasConfirmedHiddenIngredient(detectedItems)) return null;

  const labels = getRelevantHiddenIngredientLabels(possibleHiddenIngredients);

  if (labels.length === 0) {
    return null;
  }

  return (
    COPY.hiddenIngredients.confirmPrefix +
    joinIngredientLabels(labels) +
    (labels.length === 1
      ? COPY.hiddenIngredients.confirmSuffix
      : COPY.hiddenIngredients.confirmSuffixPlural)
  );
}

function hasSnackCarbProteinPattern(mealType, totals) {
  return normalizeMealType(mealType) === "snack" && numeric(totals.carbs_g) >= 35 && numeric(totals.protein_g) < 10;
}

function hasHighFatShare(totals = {}, totalsComplete) {
  const calories = numeric(totals.calories);
  if (!totalsComplete || calories <= 0) return false;
  return (numeric(totals.fat_g) * 9) / calories > 0.45;
}

function createSummary({ mode, totals, goals }) {
  const calories = numeric(totals.calories);
  const protein = numeric(totals.protein_g);

  if (mode === "personalized" && goals) {
    const calorieShare = goals.dailyCalories > 0 ? Math.round((calories / goals.dailyCalories) * 100) : 0;
    const proteinShare = goals.dailyProtein > 0 ? Math.round((protein / goals.dailyProtein) * 100) : 0;
    return "Esta comida aporta aproximadamente " + calorieShare + "% de tus calorías diarias y " + proteinShare + "% de tu objetivo de proteína.";
  }

  return "Lectura contextual basada en los alimentos calculados y el tipo de comida seleccionado.";
}

function chooseHeadline({ calorieAssessment, proteinAssessment, hiddenWarning, snackPattern }) {
  if (calorieAssessment.status === "very_high") return COPY.headlines.veryHighEnergy;
  if (calorieAssessment.status === "high") return COPY.headlines.highEnergy;
  if (["very_low", "low"].includes(proteinAssessment.status)) return COPY.headlines.lowProtein;
  if (snackPattern) return COPY.headlines.lowProtein;
  if (hiddenWarning) return COPY.headlines.hiddenIngredients;
  if (["adequate", "solid", "high"].includes(proteinAssessment.status) || ["in_range", "near_range"].includes(calorieAssessment.status)) {
    return COPY.headlines.balanced;
  }
  return COPY.headlines.default;
}

function passesContextualProductRule(rule, totals) {
  const caloriesPass = numeric(totals.calories) >= rule.caloriesAt;
  const carbsPass =
    typeof rule.carbsAt === "number" &&
    numeric(totals.carbs_g) >= rule.carbsAt;

  return caloriesPass || carbsPass;
}

function contextualRecommendationText(mealType, currentProtein) {
  if (mealType === "snack") {
    return "Actualmente aporta " + round(currentProtein, 1) + " g de proteína. Agregar entre 10 y 15 g podría hacer esta colación más completa.";
  }

  if (mealType === "desayuno") {
    return "Actualmente aporta " + round(currentProtein, 1) + " g de proteína. Agregar una fuente de proteína podría hacer este desayuno más completo y saciante.";
  }

  if (mealType === "comida") {
    return "Actualmente aporta " + round(currentProtein, 1) + " g de proteína. Primero considera una fuente de comida real para reforzar esta comida principal.";
  }

  if (mealType === "cena") {
    return "Actualmente aporta " + round(currentProtein, 1) + " g de proteína. Primero considera una fuente de comida real para reforzar esta cena.";
  }

  return "Actualmente aporta " + round(currentProtein, 1) + " g de proteína. Agregar una fuente de proteína podría hacer esta comida más completa.";
}

function contextualProductText(mealType, product, projectedProtein) {
  if (mealType === "snack") {
    return "Una porción aporta " + round(product.proteinPerServing, 1) + " g de proteína y puede ser una opción práctica. También puedes agregar yogur, queso cottage u otra fuente de proteína.";
  }

  if (mealType === "desayuno") {
    return "Una porción aporta " + round(product.proteinPerServing, 1) + " g de proteína y puede ser una opción práctica. También puedes agregar huevo, yogur u otra fuente de proteína.";
  }

  return "Royal Iso Gold aporta " + round(product.proteinPerServing, 1) + " g de proteína por porción y podría llevar esta comida aproximadamente a " + round(projectedProtein, 1) + " g si necesitas una alternativa práctica.";
}

function createProductRecommendation({ mode, mealType, totals, goals, proteinAssessment, totalsComplete, itemsPending, analysisConfidence }) {
  const product = ROYAL_PRODUCTS.isoGold;
  const normalizedMealType = normalizeMealType(mealType);
  const currentProtein = numeric(totals.protein_g);

  if (!product?.enabled || !totalsComplete || itemsPending > 0 || analysisConfidence === "low") {
    return null;
  }

  if (!proteinAssessment) {
    return null;
  }

  let minimumProteinTarget = null;
  let recommendationTarget = null;
  let proteinGap = 0;
  let isContextualRecommendation = false;

  if (mode === "personalized" && goals) {
    const range = MEAL_SHARE_RANGES.protein[normalizedMealType];
    if (!range) return null;
    minimumProteinTarget = goals.dailyProtein * range.min;
    recommendationTarget = goals.dailyProtein * range.max;
    proteinGap = minimumProteinTarget - currentProtein;

    if (
      !["very_low", "low"].includes(proteinAssessment.status) ||
      proteinGap < PERSONALIZED_PRODUCT_GAP_THRESHOLD_G
    ) {
      return null;
    }
  } else {
    const rule = CONTEXTUAL_PRODUCT_RULES[normalizedMealType] || CONTEXTUAL_PRODUCT_RULES.otro;
    const bands = CONTEXTUAL_PROTEIN_BANDS[normalizedMealType] || CONTEXTUAL_PROTEIN_BANDS.otro;

    if (!["very_low", "low"].includes(proteinAssessment.status)) return null;
    if (currentProtein >= rule.proteinBelow) return null;
    if (!passesContextualProductRule(rule, totals)) return null;

    minimumProteinTarget = rule.proteinBelow;
    recommendationTarget = bands.adequateBelow;
    proteinGap = recommendationTarget - currentProtein;
    isContextualRecommendation = true;
  }

  const projectedProtein = currentProtein + product.proteinPerServing;
  const practicalFirst = ["snack", "desayuno"].includes(normalizedMealType);
  const headline = isContextualRecommendation && normalizedMealType === "snack"
    ? COPY.recommendation.snackHeadline
    : COPY.recommendation.headline;
  const text = isContextualRecommendation
    ? contextualRecommendationText(normalizedMealType, currentProtein)
    : "Actualmente aporta " + round(currentProtein, 1) + " g de proteína. Para este tipo de comida, tu rango orientativo comienza aproximadamente en " + round(minimumProteinTarget, 1) + " g.";
  const productText = isContextualRecommendation
    ? contextualProductText(normalizedMealType, product, projectedProtein)
    : "Una porción aporta " + round(product.proteinPerServing, 1) + " g de proteína y podría llevar esta comida aproximadamente a " + round(projectedProtein, 1) + " g.";

  return {
    id: product.id,
    productId: product.id,
    label: COPY.labels.recommendation,
    headline,
    text,
    productName: product.name,
    productText,
    realFoodText: isContextualRecommendation && normalizedMealType === "snack"
      ? COPY.recommendation.snackRealFoodFirst
      : COPY.recommendation.realFoodFirst,
    contextText: practicalFirst ? COPY.recommendation.practicalOption : COPY.recommendation.mealFirst,
    ctaText: COPY.recommendation.cta,
    productUrl: product.productUrl || "",
    imageUrl: product.imageUrl || "",
    caloriesPerServing: product.caloriesPerServing,
    currentProtein: round(currentProtein, 1),
    minimumProteinTarget: round(minimumProteinTarget, 1),
    projectedProtein: round(projectedProtein, 1),
    proteinGap: round(proteinGap, 1),
  };
}

function createRoyalReading(input = {}) {
  const totals = input.totals || {};
  const goals = normalizeRoyalGoals(input.goals);
  const mode = goals ? "personalized" : "contextual";
  const itemsPending = Number.isFinite(Number(input.itemsPending))
    ? Number(input.itemsPending)
    : numeric(totals.items_pending);
  const totalsComplete = input.totalsComplete !== undefined
    ? input.totalsComplete === true
    : totals.totals_complete !== false && itemsPending === 0;
  const analysisConfidence = input.analysisConfidence || null;
  const calorieAssessment = assessCalories({ mealType: input.mealType, calories: totals.calories, goals, mode });
  const proteinAssessment = assessProtein({ mealType: input.mealType, protein: totals.protein_g, goals, mode });

  if (!totalsComplete || itemsPending > 0) {
    return {
      mode,
      headline: COPY.headlines.pending,
      summary: COPY.critical.pendingSummary,
      positiveMessage: null,
      watchMessage: null,
      actionMessage: null,
      calorieAssessment,
      proteinAssessment,
      productRecommendation: null,
    };
  }

  if (analysisConfidence === "low") {
    return {
      mode,
      headline: COPY.headlines.lowConfidence,
      summary: COPY.critical.lowConfidenceSummary,
      positiveMessage: null,
      watchMessage: null,
      actionMessage: null,
      calorieAssessment,
      proteinAssessment,
      productRecommendation: null,
    };
  }

  const hiddenIngredientMessage = createHiddenIngredientMessage(input.possibleHiddenIngredients || [], input.detectedItems || []);
  const hiddenWarning = Boolean(hiddenIngredientMessage);
  const snackPattern = hasSnackCarbProteinPattern(input.mealType, totals);
  const highFat = hasHighFatShare(totals, totalsComplete);
  const isLargePersonalizedSnack = mode === "personalized" && normalizeMealType(input.mealType) === "snack" && calorieAssessment.share !== null && calorieAssessment.share > 0.20;

  let positiveMessage = null;
  let watchMessage = null;
  let actionMessage = null;

  if (["very_high", "high"].includes(calorieAssessment.status)) {
    watchMessage = calorieAssessment.message;
  }

  if (["very_low", "low"].includes(proteinAssessment.status)) {
    actionMessage = proteinAssessment.message;
  }

  if (snackPattern) {
    actionMessage = COPY.snacks.carbFocused;
    if (isLargePersonalizedSnack) {
      watchMessage = watchMessage || COPY.snacks.largePersonalized;
    }
  }

  if (hiddenWarning) {
    if (!watchMessage) {
      watchMessage = hiddenIngredientMessage;
    } else if (!actionMessage) {
      actionMessage = hiddenIngredientMessage;
    }
  }

  if (!watchMessage && highFat) {
    watchMessage = COPY.fat.highShare;
  }

  if (["adequate", "solid", "high"].includes(proteinAssessment.status)) {
    positiveMessage = proteinAssessment.status === "adequate" ? COPY.positive.proteinCovered : proteinAssessment.message;
  } else if (["in_range", "near_range"].includes(calorieAssessment.status)) {
    positiveMessage = calorieAssessment.message;
  } else if (!watchMessage && !actionMessage) {
    positiveMessage = COPY.positive.ready;
  }

  const productRecommendation = createProductRecommendation({
    mode,
    mealType: input.mealType,
    totals,
    goals,
    proteinAssessment,
    totalsComplete,
    itemsPending,
    analysisConfidence,
  });

  return {
    mode,
    headline: chooseHeadline({ calorieAssessment, proteinAssessment, hiddenWarning, snackPattern }),
    summary: createSummary({ mode, totals, goals }),
    positiveMessage,
    watchMessage,
    actionMessage,
    calorieAssessment,
    proteinAssessment,
    productRecommendation,
  };
}

exports.normalizeMealType = normalizeMealType;
exports.assessCalories = assessCalories;
exports.assessProtein = assessProtein;
exports.createRoyalReading = createRoyalReading;
},
"./royal-goals.js": function(module, exports, __require) {
const ROYAL_GOALS_STORAGE_KEY = exports.ROYAL_GOALS_STORAGE_KEY = "royal_goals_v1";

const LEGACY_GOALS_STORAGE_KEYS = exports.LEGACY_GOALS_STORAGE_KEYS = Object.freeze([]);

const GOAL_VALUES = new Set(["lose_fat", "maintain", "gain_muscle", "unknown"]);
const SOURCE_VALUES = new Set(["royal_calculator", "manual"]);

function toFiniteNumber(value) {
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
}

function isIsoDate(value) {
  return typeof value === "string" && Number.isFinite(Date.parse(value));
}

function normalizeRoyalGoals(value) {
  let source = value;

  if (typeof source === "string") {
    try {
      source = JSON.parse(source);
    } catch {
      return null;
    }
  }

  if (!source || typeof source !== "object") {
    return null;
  }

  const dailyCalories = toFiniteNumber(source.dailyCalories);
  const dailyProtein = toFiniteNumber(source.dailyProtein);

  if (dailyCalories === null || dailyCalories < 1000 || dailyCalories > 6000) {
    return null;
  }

  if (dailyProtein === null || dailyProtein < 40 || dailyProtein > 350) {
    return null;
  }

  if (!isIsoDate(source.updatedAt)) {
    return null;
  }

  return {
    dailyCalories,
    dailyProtein,
    goal: GOAL_VALUES.has(source.goal) ? source.goal : "unknown",
    source: SOURCE_VALUES.has(source.source) ? source.source : "manual",
    updatedAt: new Date(source.updatedAt).toISOString(),
  };
}

function createRoyalGoalsDraft(values = {}, now = Date.now()) {
  return {
    dailyCalories: Number(values.dailyCalories),
    dailyProtein: Number(values.dailyProtein),
    goal: GOAL_VALUES.has(values.goal) ? values.goal : "unknown",
    source: SOURCE_VALUES.has(values.source) ? values.source : "manual",
    updatedAt: new Date(Number.isFinite(now) ? now : Date.now()).toISOString(),
  };
}

function safeStorage(storage) {
  if (storage) return storage;

  try {
    return globalThis.localStorage || null;
  } catch {
    return null;
  }
}

function loadRoyalGoals(storage) {
  const target = safeStorage(storage);

  if (!target) {
    return null;
  }

  try {
    const canonical = normalizeRoyalGoals(target.getItem(ROYAL_GOALS_STORAGE_KEY));
    if (canonical) return canonical;

    for (const key of LEGACY_GOALS_STORAGE_KEYS) {
      const legacy = normalizeRoyalGoals(target.getItem(key));
      if (legacy) return legacy;
    }
  } catch {
    return null;
  }

  return null;
}

function saveRoyalGoals(values, storage, now = Date.now()) {
  const goals = normalizeRoyalGoals(createRoyalGoalsDraft(values, now));

  if (!goals) {
    throw new Error("Objetivos Royal inválidos");
  }

  const target = safeStorage(storage);

  if (target) {
    try {
      target.setItem(ROYAL_GOALS_STORAGE_KEY, JSON.stringify(goals));
    } catch {
      // El navegador puede bloquear localStorage. La lectura puede seguir usando los objetivos en memoria.
    }
  }

  return goals;
}

function clearRoyalGoals(storage) {
  const target = safeStorage(storage);
  if (!target) return;

  try {
    target.removeItem(ROYAL_GOALS_STORAGE_KEY);
  } catch {
    // No-op seguro.
  }
}

exports.normalizeRoyalGoals = normalizeRoyalGoals;
exports.createRoyalGoalsDraft = createRoyalGoalsDraft;
exports.loadRoyalGoals = loadRoyalGoals;
exports.saveRoyalGoals = saveRoyalGoals;
exports.clearRoyalGoals = clearRoyalGoals;
},
"./royal-reading-copy.js": function(module, exports, __require) {
const ROYAL_READING_COPY = exports.ROYAL_READING_COPY = Object.freeze({
  labels: {
    reading: "LECTURA ROYAL",
    recommendation: "RECOMENDACIÓN ROYAL",
    positive: "Lo mejor",
    watch: "Revisa",
    action: "Ajuste práctico",
  },
  headlines: {
    default: "Estimación lista para revisar",
    balanced: "Buena base para esta comida",
    lowProtein: "Tu comida podría beneficiarse de más proteína",
    hiddenIngredients: "Confirma extras que pueden cambiar el total",
    highEnergy: "Esta comida usa una parte importante de tu día",
    veryHighEnergy: "Revisa el tamaño de esta comida",
    pending: "Revisa algunos alimentos antes de aceptar",
    lowConfidence: "Esta estimación necesita revisión",
  },
  critical: {
    pendingSummary: "Hay elementos sin confirmar y la Lectura Royal todavía no puede evaluar completamente esta comida.",
    lowConfidenceSummary: "La identificación o la porción no son suficientemente claras. Corrige o confirma el resultado antes de usar esta lectura como referencia.",
  },
  calories: {
    low: "Esta comida es ligera respecto a tu objetivo diario.",
    near_range: "El aporte energético está cerca del rango orientativo para este tipo de comida.",
    in_range: "El aporte energético está bien alineado con este tipo de comida.",
    high: "Esta comida utiliza una parte considerable de tus calorías diarias.",
    very_high: "Para este tipo de comida, el aporte energético es elevado respecto a tu objetivo diario.",
    contextualSnackLarge: "Por su aporte energético, esta colación se parece más a una comida ligera.",
  },
  protein: {
    very_low: "Esta comida aporta poca proteína.",
    low: "Esta comida podría beneficiarse de más proteína.",
    near_target: "La proteína está cerca del rango orientativo para esta comida.",
    adequate: "Buena cantidad de proteína para este tipo de comida.",
    solid: "Esta comida aporta una cantidad sólida de proteína.",
    high: "Esta comida aporta una cantidad sólida de proteína.",
  },
  contextualProtein: {
    desayuno: {
      very_low: "Este desayuno aporta poca proteína.",
      low: "Este desayuno es ligero en proteína.",
      adequate: "Este desayuno aporta una cantidad adecuada de proteína.",
      solid: "Este desayuno aporta una cantidad sólida de proteína.",
      high: "Este es un desayuno alto en proteína.",
    },
    comida: {
      very_low: "Esta comida principal aporta poca proteína.",
      low: "Esta comida principal es ligera en proteína.",
      adequate: "Buena cantidad de proteína para una comida principal.",
      solid: "Esta comida principal aporta una cantidad sólida de proteína.",
      high: "Esta comida principal es alta en proteína.",
    },
    cena: {
      very_low: "Esta cena aporta poca proteína.",
      low: "Esta cena es ligera en proteína.",
      adequate: "Esta cena aporta una cantidad adecuada de proteína.",
      solid: "Esta cena aporta una cantidad sólida de proteína.",
      high: "Esta cena es alta en proteína.",
    },
    snack: {
      very_low: "Esta colación aporta poca proteína.",
      low: "Esta colación es ligera en proteína.",
      adequate: "Esta colación aporta una cantidad adecuada de proteína.",
      solid: "Esta colación aporta una cantidad sólida de proteína.",
      high: "Esta es una colación alta en proteína.",
    },
    otro: {
      very_low: "Esta comida aporta poca proteína.",
      low: "Esta comida es ligera en proteína.",
      adequate: "Esta comida aporta una cantidad adecuada de proteína.",
      solid: "Esta comida aporta una cantidad sólida de proteína.",
      high: "Esta comida es alta en proteína.",
    },
  },
  snackProtein: {
    very_low: "Esta colación aporta poca proteína.",
    low: "Esta colación es ligera en proteína.",
    adequate: "Esta colación aporta una cantidad adecuada de proteína.",
    solid: "Esta colación aporta una cantidad sólida de proteína.",
    high: "Esta es una colación alta en proteína.",
  },
  snacks: {
    carbFocused: "Esta colación está concentrada en carbohidratos y podría saciar más si agregas proteína.",
    largePersonalized: "Por su tamaño, esta colación podría funcionar mejor como una comida ligera.",
  },
  hiddenIngredients: {
    confirmPrefix: "Revisa ",
    confirmSuffix: ": podría cambiar significativamente el total.",
    confirmSuffixPlural: ": podrían cambiar significativamente el total.",
  },
  fat: {
    highShare: "Una parte importante de las calorías de esta comida proviene de grasas.",
  },
  positive: {
    ready: "La estimación ya puede revisarse con los nutrientes calculados por el catálogo Royal.",
    proteinCovered: "Proteína bien cubierta.",
  },
  recommendation: {
    headline: "Tu comida podría beneficiarse de más proteína",
    snackHeadline: "Agregar una fuente de proteína podría hacer esta colación más completa y saciante.",
    productName: "Royal Iso Gold",
    cta: "Ver Royal Iso Gold",
    realFoodFirst: "También puedes agregar una fuente de proteína como pollo, huevo, atún, yogur o legumbres.",
    snackRealFoodFirst: "También puedes agregar yogur, queso cottage u otra fuente de proteína.",
    practicalOption: "Royal Iso Gold puede ser una opción práctica cuando buscas reforzar proteína sin preparar otra comida completa.",
    mealFirst: "Primero puedes reforzar con una fuente de proteína de comida real; Royal Iso Gold queda como alternativa práctica.",
  },
});

},
"./royal-products.js": function(module, exports, __require) {
const ROYAL_PRODUCTS = exports.ROYAL_PRODUCTS = Object.freeze({
  isoGold: Object.freeze({
    id: "iso-gold",
    name: "Royal Iso Gold",
    proteinPerServing: 27.5,
    caloriesPerServing: null,
    productUrl: "",
    imageUrl: "",
    enabled: true,
  }),
});

},
"./nutrition-ui.js": function(module, exports, __require) {
function formatNumber(value, digits = 0) {
  if (value === null || value === undefined || value === "") {
    return "—";
  }

  const number = Number(value);

  if (!Number.isFinite(number)) {
    return "—";
  }

  return new Intl.NumberFormat("es-MX", {
    maximumFractionDigits: digits,
    minimumFractionDigits: digits,
  }).format(number);
}

function formatCalories(value) {
  return formatNumber(value, 0) + " kcal";
}

function formatMacro(value) {
  return formatNumber(value, 1) + " g";
}

function confidenceLabel(type, value) {
  const labels = {
    identity: {
      high: "Alimento identificado con alta confianza",
      medium: "Revisa la identificación",
      low: "Identificación poco segura",
    },
    portion: {
      high: "Porción bastante clara",
      medium: "Porción aproximada",
      low: "Revisa la cantidad",
    },
  };

  return labels[type]?.[value] || "Confianza por revisar";
}

function confidenceTone(value) {
  return {
    high: "success",
    medium: "warning",
    low: "danger",
  }[value] || "neutral";
}

function sourceLabel(source) {
  return {
    detected: "Detectado por IA",
    manual_catalog: "Agregado del catálogo",
    hidden_ingredient: "Ingrediente oculto confirmado",
    manual_nutrition: "Nutrición manual",
  }[source] || "Fuente por revisar";
}

function escapeHtml(value) {
  return String(value ?? "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#039;");
}

function createDebouncedSearch(searchFn, delay = 300) {
  let timer = null;
  let lastReject = null;

  return function debouncedSearch(query) {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }

    if (lastReject) {
      lastReject({ cancelled: true });
      lastReject = null;
    }

    return new Promise((resolve, reject) => {
      lastReject = reject;
      timer = setTimeout(async () => {
        timer = null;
        lastReject = null;
        try {
          resolve(await searchFn(query));
        } catch (error) {
          reject(error);
        }
      }, delay);
    });
  };
}

function describeApiError(error) {
  const fallback = {
    title: "No pudimos completar la acción",
    text: "Intenta de nuevo o continúa en modo manual.",
    retry: true,
    manual: true,
  };

  const map = {
    IMAGE_REQUIRED: {
      title: "Falta la fotografía",
      text: "Selecciona una imagen clara del plato para analizarla.",
      retry: true,
      manual: true,
    },
    INVALID_IMAGE_TYPE: {
      title: "Formato no compatible",
      text: "Usa una imagen JPG, PNG o WEBP.",
      retry: true,
      manual: true,
    },
    IMAGE_TOO_LARGE: {
      title: "La imagen es muy pesada",
      text: "Prueba con una fotografía más ligera o tomada desde más cerca.",
      retry: true,
      manual: true,
    },
    NO_FOOD_DETECTED: {
      title: "No detectamos comida con claridad",
      text: "Puedes probar otra foto o calcular la comida manualmente.",
      retry: true,
      manual: true,
    },
    ANALYSIS_TIMEOUT: {
      title: "El análisis tardó demasiado",
      text: "Vuelve a intentarlo. Si sigue pasando, usa el modo manual.",
      retry: true,
      manual: true,
    },
    GEMINI_QUOTA_REACHED: {
      title: "El análisis automático está limitado ahora",
      text: "Puedes seguir calculando con el modo manual sin usar IA.",
      retry: false,
      manual: true,
    },
    CLIENT_DAILY_LIMIT: {
      title: "0 anÃ¡lisis disponibles hoy",
      text: "Tus anÃ¡lisis automÃ¡ticos de hoy se agotaron. Puedes continuar en modo manual.",
      retry: false,
      manual: true,
    },
    GLOBAL_DAILY_LIMIT: {
      title: "AnÃ¡lisis automÃ¡ticos agotados por hoy",
      text: "Los anÃ¡lisis automÃ¡ticos de hoy se agotaron. Puedes continuar en modo manual.",
      retry: false,
      manual: true,
    },
    BURST_RATE_LIMIT: {
      title: "Demasiadas solicitudes seguidas",
      text: "Espera unos minutos o continÃºa en modo manual.",
      retry: false,
      manual: true,
    },
    GEMINI_AUTH_ERROR: {
      title: "El servicio de análisis no está disponible",
      text: "El backend no pudo autenticarse con Gemini. Usa el modo manual mientras se revisa la configuración.",
      retry: false,
      manual: true,
    },
    GEMINI_UPSTREAM_ERROR: {
      title: "Gemini no respondió correctamente",
      text: "Intenta de nuevo en unos segundos o continúa en modo manual.",
      retry: true,
      manual: true,
    },
    INVALID_GEMINI_RESPONSE: {
      title: "La IA devolvió una respuesta incompleta",
      text: "Puedes reintentar con otra foto o usar el modo manual.",
      retry: true,
      manual: true,
    },
    NETWORK_ERROR: {
      title: "No encontramos el backend local",
      text: "No pudimos conectar con el servicio de análisis. Intenta de nuevo o continúa en modo manual.",
      retry: true,
      manual: true,
    },
    ORIGIN_NOT_ALLOWED: {
      title: "Origen no permitido",
      text: "El origen de esta página no está permitido por el servicio de análisis.",
      retry: false,
      manual: true,
    },
  };

  return map[error?.code] || {
    ...fallback,
    text: error?.message || fallback.text,
  };
}

exports.formatNumber = formatNumber;
exports.formatCalories = formatCalories;
exports.formatMacro = formatMacro;
exports.confidenceLabel = confidenceLabel;
exports.confidenceTone = confidenceTone;
exports.sourceLabel = sourceLabel;
exports.escapeHtml = escapeHtml;
exports.createDebouncedSearch = createDebouncedSearch;
exports.describeApiError = describeApiError;
},
};
const __cache = {};
function __require(id) {
  if (__cache[id]) return __cache[id].exports;
  const factory = __modules[id];
  if (!factory) throw new Error("Royal Food Scanner module not found: " + id);
  const module = { exports: {} };
  __cache[id] = module;
  factory(module, module.exports, __require);
  return module.exports;
}
__require("./entry.js");
})();
